import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prototype5');
import { OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type StageStatus = 'ready' | 'planned' | 'guarded';

interface PipelineStage {
    id: number;
    title: string;
    status: StageStatus;
    outcome: string;
    models: string[];
    build: string[];
    limits: string[];
    future?: string[];
    evidence?: string[];
}

interface LegalPipelineStep {
    order: number;
    title: string;
    description: string;
    current: string;
}

interface TranscriptRow {
    id: number;
    time: string;
    rawSpeaker: string;
    refinedSpeaker: string;
    confidence: number;
    text: string;
    signal: string;
    tension: number;
    start?: number;
    end?: number;
    summary?: any;
    diagnostics?: any;
    speakerDiagnostics?: any;
    timings?: any;
    merged?: boolean;
}

interface AudioChunkRow {
    index: number;
    time: string;
    sizeKb: number;
    mimeType: string;
    status: string;
    timings?: any;
}

interface ModelReadiness {
    whisper: boolean;
    silero: boolean;
    pyannote: boolean;
    textAnalysis?: boolean;
    textWarmupMs?: number;
    rag?: boolean;
    ragMethod?: string;
    ragSourceCount?: number;
    ragChunkCount?: number;
    llm?: boolean;
    llmStatus?: string;
    visual?: boolean;
    visualStatus?: string;
}

interface SessionHistoryItem {
    id: string;
    title: string;
    preview: string;
    topic: string;
    turnCount: number;
    updatedAt: number;
    transcriptRows: TranscriptRow[];
    audioChunks: AudioChunkRow[];
    autoConversationSummary: any;
    ragInput: string;
    ragResult: any;
    conflictSummary: any;
    latestAudioTimings: any;
    latestTextAnalysisTimings: any;
}

@Component({
    selector: 'wiz-page-prototype5',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prototype5/view.scss */
:host {
  display: block;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
  color: #16343a;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --vm-ink: #16343a;
  --vm-ink-soft: #507178;
  --vm-ink-muted: #6f8f95;
  --vm-accent: #1bcac2;
  --vm-accent-strong: #44d99f;
  --vm-accent-deep: #119d97;
  --vm-accent-pale: #e8fbf8;
  --vm-accent-pale-2: #f4fffd;
  --vm-surface: #f7fdfc;
  --vm-surface-2: #eef8f6;
  --vm-surface-3: #e4f3f0;
  --vm-card: #ffffff;
  --vm-line: #cfe7e2;
  --vm-line-strong: #b7ddd6;
  --vm-sidebar-bg: #11343a;
  --vm-sidebar-bg-2: #184249;
  --vm-sidebar-line: rgba(147, 220, 206, 0.18);
  --vm-sidebar-text: #e9fbf8;
  --vm-sidebar-muted: #a8cbc7;
  --vm-shadow-sm: 0 1px 2px rgba(17, 90, 89, 0.08);
  --vm-shadow-md: 0 14px 40px rgba(18, 85, 83, 0.12);
  --vm-shadow-lg: 0 24px 80px rgba(12, 61, 60, 0.22);
}

* {
  box-sizing: border-box;
}

button,
select,
textarea {
  font: inherit;
}

button {
  transition: background-color 140ms ease, color 140ms ease, border-color 140ms ease, transform 140ms ease;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.vm-shell {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr) 360px;
  height: 100vh;
  max-height: 100vh;
  min-height: 0;
  overflow: hidden;
  background: linear-gradient(180deg, var(--vm-surface) 0%, #f4fbfa 100%);
}

.vm-sidebar {
  display: flex;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid var(--vm-sidebar-line);
  background: radial-gradient(circle at top, rgba(68, 217, 159, 0.16), transparent 28%), linear-gradient(180deg, var(--vm-sidebar-bg) 0%, var(--vm-sidebar-bg-2) 100%);
  color: var(--vm-sidebar-text);
}

.vm-sidebar-top,
.vm-sidebar-section,
.vm-sidebar-footer {
  padding: 16px;
}

.vm-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.vm-brand-logo,
.vm-empty-logo {
  display: block;
  object-fit: contain;
}

.vm-brand-mark,
.vm-empty-mark {
  display: grid;
  place-items: center;
  border-radius: 12px;
  background: var(--vm-card);
  color: var(--vm-ink);
  font-weight: 800;
}

.vm-brand-mark {
  width: 34px;
  height: 34px;
  font-size: 12px;
}

.vm-brand-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  padding: 2px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}

.vm-empty-logo {
  width: 92px;
  height: 92px;
  margin: 0 auto 14px;
}

.vm-brand-title,
.vm-chat-title,
.vm-inspector-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
}

.vm-brand-subtitle,
.vm-chat-subtitle,
.vm-inspector-subtitle,
.vm-muted-line,
.vm-muted {
  color: var(--vm-ink-muted);
  font-size: 12px;
  line-height: 1.45;
}

.vm-sidebar .vm-brand-subtitle,
.vm-sidebar .vm-muted-line,
.vm-sidebar .vm-muted,
.vm-sidebar .vm-camera-actions,
.vm-sidebar .vm-status-pill {
  color: var(--vm-sidebar-muted);
}

.vm-new-chat,
.vm-session-item,
.vm-ghost-control,
.vm-secondary-control,
.vm-primary-control,
.vm-danger-control,
.vm-header-button,
.vm-wide-button,
.vm-prompt-card,
.vm-icon-button,
.vm-send-button {
  border: 0;
  cursor: pointer;
}

.vm-new-chat {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;
  margin-top: 18px;
  padding: 11px 12px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(27, 202, 194, 0.18), rgba(68, 217, 159, 0.18));
  color: #f4fffd;
  box-shadow: inset 0 0 0 1px rgba(132, 237, 216, 0.16);
  font-weight: 650;
}

.vm-new-chat:hover,
.vm-session-item:hover,
.vm-ghost-control:hover,
.vm-secondary-control:hover {
  background: rgba(131, 232, 214, 0.16);
}

.vm-plus {
  font-size: 18px;
  line-height: 1;
}

.vm-session-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 6px 8px 12px;
}

.vm-session-empty {
  padding: 10px 12px;
  color: var(--vm-sidebar-muted);
  font-size: 12px;
  line-height: 1.5;
}

.vm-session-item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 10px;
  background: transparent;
  color: #d7f1ed;
  text-align: left;
  font-size: 13px;
}

.vm-session-delete {
  position: absolute;
  top: 6px;
  right: 6px;
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(233, 251, 248, 0.72);
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
}

.vm-session-delete:hover {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.vm-session-copy {
  display: grid;
  min-width: 0;
  gap: 2px;
  padding-right: 18px;
}

.vm-session-title {
  color: inherit;
  font-size: 13px;
  font-weight: 680;
}

.vm-session-subline {
  color: var(--vm-sidebar-muted);
  font-size: 11px;
  line-height: 1.4;
}

.vm-session-item.active {
  background: rgba(27, 202, 194, 0.18);
  color: #ffffff;
  box-shadow: inset 0 0 0 1px rgba(136, 239, 219, 0.16);
}

.vm-session-item.active .vm-session-subline {
  color: rgba(244, 255, 253, 0.78);
}

.vm-session-item.active .vm-session-delete {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.82);
}

.vm-session-dot,
.vm-status-light {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 999px;
  background: rgba(201, 237, 229, 0.45);
}

.vm-session-dot.live,
.vm-status-light.live {
  background: var(--vm-accent-strong);
}

.vm-section-label {
  margin-bottom: 9px;
  color: #9fc9c2;
  font-size: 11px;
  font-weight: 750;
  text-transform: uppercase;
}

.vm-control-stack {
  display: grid;
  gap: 8px;
}

.vm-primary-control,
.vm-danger-control,
.vm-secondary-control,
.vm-ghost-control,
.vm-wide-button {
  min-height: 38px;
  border-radius: 10px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.vm-primary-control,
.vm-wide-button {
  background: linear-gradient(135deg, var(--vm-accent) 0%, var(--vm-accent-strong) 100%);
  color: #083538;
  box-shadow: 0 10px 24px rgba(27, 202, 194, 0.2);
}

.vm-danger-control {
  background: linear-gradient(135deg, #f97373 0%, #ef4444 100%);
  color: #ffffff;
}

.vm-danger-control.compact {
  min-height: 30px;
}

.vm-secondary-control,
.vm-ghost-control {
  background: rgba(255, 255, 255, 0.08);
  color: #f5fffd;
  box-shadow: inset 0 0 0 1px rgba(147, 220, 206, 0.14);
}

.vm-camera-card {
  display: grid;
  gap: 10px;
}

.vm-camera-frame {
  position: relative;
  height: 150px;
  overflow: hidden;
  border: 1px solid rgba(147, 220, 206, 0.14);
  border-radius: 14px;
  background: #0c2429;
}

.vm-camera-frame video,
.vm-camera-frame canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.vm-camera-frame canvas {
  pointer-events: none;
}

.vm-camera-empty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: #9dc6c0;
  font-size: 12px;
  font-weight: 700;
}

.vm-camera-actions,
.vm-sidebar-footer,
.vm-status-pill,
.vm-header-actions,
.vm-composer-bottom,
.vm-composer-options,
.vm-composer-actions,
.vm-message-meta,
.vm-row-tools,
.vm-chip-row,
.vm-split-row,
.vm-modal-head {
  display: flex;
  align-items: center;
}

.vm-camera-actions {
  justify-content: space-between;
  gap: 8px;
  color: #a3a3a3;
  font-size: 12px;
}

.vm-sidebar-footer {
  justify-content: space-between;
  gap: 10px;
  border-top: 1px solid var(--vm-sidebar-line);
}

.vm-status-pill {
  gap: 7px;
  color: var(--vm-sidebar-muted);
  font-size: 12px;
}

.vm-main {
  display: flex;
  height: 100%;
  max-height: 100%;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  background: transparent;
}

.vm-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 0 22px;
  border-bottom: 1px solid var(--vm-line);
  background: rgba(247, 253, 252, 0.92);
  backdrop-filter: blur(14px);
}

.vm-header-actions {
  gap: 8px;
}

.vm-header-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  border: 1px solid var(--vm-line);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.85);
  color: var(--vm-ink);
  padding: 0 14px;
  font-size: 13px;
  font-weight: 700;
}

.vm-header-button:hover {
  background: var(--vm-accent-pale);
}

.vm-header-button.primary {
  border-color: transparent;
  background: linear-gradient(135deg, var(--vm-accent) 0%, var(--vm-accent-strong) 100%);
  color: #083538;
}

.vm-chat-scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  background: linear-gradient(180deg, transparent 0%, rgba(232, 251, 248, 0.36) 100%);
}

.vm-chat-inner {
  width: min(100%, 820px);
  margin: 0 auto;
  padding: 36px 20px 120px;
}

.vm-empty-state {
  display: grid;
  min-height: 58vh;
  place-items: center;
  align-content: center;
  text-align: center;
}

.vm-empty-mark {
  width: 48px;
  height: 48px;
  margin-bottom: 20px;
  border: 1px solid var(--vm-line);
  box-shadow: var(--vm-shadow-md);
}

.vm-empty-state h1 {
  margin: 0;
  font-size: clamp(26px, 4vw, 34px);
  font-weight: 750;
  letter-spacing: 0;
}

.vm-empty-state p {
  max-width: 480px;
  margin: 10px auto 0;
  color: var(--vm-ink-soft);
  font-size: 14px;
  line-height: 1.65;
}

.vm-prompt-grid {
  display: grid;
  width: min(100%, 620px);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 28px;
}

.vm-prompt-card {
  min-height: 54px;
  border: 1px solid var(--vm-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.86);
  color: var(--vm-ink);
  box-shadow: var(--vm-shadow-sm);
  padding: 0 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 650;
}

.vm-prompt-card:hover {
  background: var(--vm-accent-pale);
  border-color: var(--vm-line-strong);
}

.vm-message {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 13px;
  margin: 0 0 28px;
}

.vm-message.user {
  grid-template-columns: minmax(0, 1fr) 34px;
}

.vm-message.user .vm-avatar {
  grid-column: 2;
}

.vm-message.user .vm-message-body {
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
}

.vm-avatar {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  overflow: hidden;
  border-radius: 999px;
  background: linear-gradient(135deg, #1cbfc0 0%, #42d89f 100%);
  color: #083538;
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.vm-avatar.user {
  background: #d8f5ef;
  color: var(--vm-ink);
}

.vm-avatar.assistant {
  background: linear-gradient(135deg, #18c4c1 0%, #44d99f 100%);
  color: #083538;
}

.vm-message-body {
  max-width: min(100%, 680px);
}

.vm-message-meta {
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
  color: var(--vm-ink-muted);
  font-size: 11px;
}

.vm-bubble {
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: var(--vm-shadow-sm);
  border: 1px solid rgba(207, 231, 226, 0.78);
  padding: 12px 15px;
  color: var(--vm-ink);
  font-size: 15px;
  line-height: 1.72;
  white-space: pre-wrap;
}

.vm-message.user .vm-bubble {
  background: linear-gradient(135deg, rgba(27, 202, 194, 0.12), rgba(68, 217, 159, 0.12));
  border-color: rgba(116, 226, 203, 0.45);
}

.vm-row-tools {
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.vm-inline-select,
.vm-select {
  min-height: 30px;
  border: 1px solid var(--vm-line);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--vm-ink);
  padding: 0 9px;
  font-size: 12px;
  font-weight: 650;
}

.vm-mini-badge,
.vm-chip {
  border-radius: 999px;
  background: var(--vm-accent-pale);
  color: var(--vm-accent-deep);
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 650;
}

.vm-assistant-card,
.vm-metric-card,
.vm-detail-card,
.vm-stage-card {
  border: 1px solid var(--vm-line);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.92);
  padding: 16px;
  box-shadow: var(--vm-shadow-sm);
}

.vm-assistant-card.strong {
  border-color: #aee7db;
  background: linear-gradient(180deg, #fcffff 0%, #f1fffb 100%);
}

.vm-card-title,
.vm-value {
  font-weight: 750;
}

.vm-assistant-card p,
.vm-metric-card p,
.vm-stage-card p {
  margin: 8px 0 0;
  color: var(--vm-ink-soft);
  font-size: 13px;
  line-height: 1.7;
}

.vm-list-block {
  margin-top: 12px;
}

.vm-list-block.emphasis,
.vm-focus-card {
  border: 1px solid rgba(27, 202, 194, 0.2);
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(27, 202, 194, 0.08), rgba(68, 217, 159, 0.04));
  padding: 12px 13px;
}

.vm-list-title,
.vm-kicker {
  margin-bottom: 6px;
  color: var(--vm-ink-muted);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.vm-list-block ul,
.vm-compact-list {
  margin: 0;
  padding-left: 18px;
  color: var(--vm-ink);
  font-size: 13px;
  line-height: 1.65;
}

.vm-source-list {
  display: grid;
  gap: 7px;
  margin-top: 12px;
}

.vm-source-item {
  display: block;
  width: 100%;
  border: 1px solid rgba(27, 202, 194, 0.16);
  border-radius: 12px;
  background: var(--vm-accent-pale);
  padding: 10px 12px;
  color: var(--vm-ink);
  text-align: left;
  box-shadow: var(--vm-shadow-sm);
}

.vm-source-item.active {
  border-color: rgba(27, 202, 194, 0.48);
  background: linear-gradient(180deg, #f6fffd 0%, #ebfbf8 100%);
}

.vm-source-title {
  font-size: 12px;
  font-weight: 750;
  line-height: 1.5;
}

.vm-source-meta {
  margin-top: 4px;
  color: var(--vm-ink-muted);
  font-size: 11px;
  line-height: 1.45;
}

.vm-source-detail {
  margin-top: 12px;
  border: 1px solid rgba(27, 202, 194, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  padding: 13px 14px;
}

.vm-source-detail-title {
  color: var(--vm-ink);
  font-size: 13px;
  font-weight: 780;
  line-height: 1.5;
}

.vm-source-detail-meta {
  margin-top: 5px;
  color: var(--vm-ink-muted);
  font-size: 11px;
  line-height: 1.5;
}

.vm-source-detail-excerpt {
  margin-top: 9px;
  color: var(--vm-ink-soft);
  font-size: 13px;
  line-height: 1.72;
  white-space: pre-wrap;
}

.vm-summary-stack p:first-child {
  margin-top: 8px;
  color: var(--vm-ink);
  font-size: 14px;
  font-weight: 680;
}

.vm-summary-stack p + p {
  margin-top: 6px;
}

.vm-composer-wrap {
  flex: 0 0 auto;
  border-top: 1px solid var(--vm-line);
  background: linear-gradient(to top, rgba(247, 253, 252, 0.96) 86%, rgba(247, 253, 252, 0));
  padding: 14px 20px 20px;
}

.vm-composer {
  width: min(100%, 820px);
  margin: 0 auto;
  border: 1px solid var(--vm-line-strong);
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.94);
  padding: 12px;
  box-shadow: var(--vm-shadow-md);
}

.vm-composer-input {
  display: block;
  width: 100%;
  min-height: 38px;
  max-height: 150px;
  resize: vertical;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--vm-ink);
  padding: 6px 8px;
  font-size: 15px;
  line-height: 1.55;
}

.vm-composer-bottom {
  justify-content: space-between;
  gap: 10px;
  margin-top: 6px;
}

.vm-composer-options,
.vm-composer-actions,
.vm-chip-row {
  flex-wrap: wrap;
  gap: 8px;
}

.vm-icon-button,
.vm-send-button {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 999px;
}

.vm-icon-button {
  background: var(--vm-accent-pale);
  color: var(--vm-accent-deep);
}

.vm-send-button {
  background: linear-gradient(135deg, var(--vm-accent) 0%, var(--vm-accent-strong) 100%);
  color: #083538;
  font-size: 18px;
  box-shadow: 0 10px 24px rgba(27, 202, 194, 0.24);
}

.vm-inspector {
  display: flex;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  border-left: 1px solid var(--vm-line);
  background: linear-gradient(180deg, #f4fcfb 0%, #eef8f6 100%);
}

.vm-inspector-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 18px;
  border-bottom: 1px solid var(--vm-line);
  background: rgba(255, 255, 255, 0.92);
}

.vm-risk-score {
  border-radius: 999px;
  background: var(--vm-accent-pale);
  color: var(--vm-accent-deep);
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 800;
}

.vm-tabbar {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.92);
}

.vm-tabbar button {
  min-height: 34px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--vm-ink-soft);
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.vm-tabbar button.active {
  background: linear-gradient(135deg, var(--vm-accent) 0%, var(--vm-accent-strong) 100%);
  color: #083538;
}

.vm-inspector-scroll {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 14px;
}

.vm-panel-stack {
  display: grid;
  gap: 12px;
}

.vm-metric-card.dark {
  background: linear-gradient(135deg, #12343a 0%, #1c4f55 100%);
  color: #ecfffb;
}

.vm-metric-card.dark .vm-kicker {
  color: #bdebe3;
}

.vm-big {
  font-size: 24px;
  font-weight: 800;
}

.vm-meter {
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  margin-top: 12px;
}

.vm-meter div {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--vm-accent) 0%, var(--vm-accent-strong) 100%);
}

.vm-alert {
  border-radius: 12px;
  background: rgba(27, 202, 194, 0.12);
  color: #0e7d77;
  border: 1px solid rgba(27, 202, 194, 0.18);
  padding: 9px 10px;
  font-size: 12px;
  font-weight: 700;
}

.vm-split-row {
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  color: var(--vm-ink-soft);
  font-size: 12px;
}

.vm-side-textarea {
  width: 100%;
  resize: none;
  border: 1px solid var(--vm-line);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  padding: 12px;
  outline: 0;
  color: var(--vm-ink);
  font-size: 13px;
  line-height: 1.6;
}

.vm-toggle-line {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 12px;
  color: var(--vm-ink-soft);
  font-size: 12px;
  font-weight: 700;
}

.vm-eval-actions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.vm-eval-actions button {
  min-height: 34px;
  border: 1px solid var(--vm-line);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.92);
  color: var(--vm-ink);
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.vm-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 999px;
  animation: vm-spin 0.8s linear infinite;
}

@keyframes vm-spin {
  to {
    transform: rotate(360deg);
  }
}
.vm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  background: rgba(12, 61, 60, 0.32);
  padding: 24px;
}

.vm-modal {
  display: flex;
  width: min(960px, 100%);
  max-height: min(780px, 92vh);
  flex-direction: column;
  overflow: hidden;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: var(--vm-shadow-lg);
}

.vm-modal-head {
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--vm-line);
}

.vm-modal-title {
  font-weight: 800;
}

.vm-modal-subtitle {
  color: var(--vm-ink-muted);
  font-size: 12px;
}

.vm-modal-body {
  overflow: auto;
  padding: 18px;
}

.vm-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.vm-stage-list {
  display: grid;
  gap: 10px;
}

.text-emerald-600,
.text-emerald-700 {
  color: #0da88f;
}

.text-amber-600,
.text-amber-700 {
  color: #d08a28;
}

.text-rose-600,
.text-rose-700 {
  color: #de5a75;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1180px) {
  .vm-shell {
    grid-template-columns: 250px minmax(0, 1fr);
  }
  .vm-inspector {
    display: none;
  }
}
@media (max-width: 820px) {
  .vm-shell {
    grid-template-columns: 1fr;
  }
  .vm-sidebar {
    display: none;
  }
  .vm-chat-header {
    padding: 0 14px;
  }
  .vm-header-actions {
    display: none;
  }
  .vm-chat-inner {
    padding: 24px 14px 110px;
  }
  .vm-prompt-grid,
  .vm-detail-grid {
    grid-template-columns: 1fr;
  }
  .vm-composer-wrap {
    padding: 12px;
  }
  .vm-message.user,
  .vm-message {
    grid-template-columns: 30px minmax(0, 1fr);
  }
  .vm-message.user .vm-avatar {
    grid-column: 1;
  }
  .vm-message.user .vm-message-body {
    grid-column: 2;
    justify-self: stretch;
  }
}`],
})
export class PagePrototype5Component implements OnInit, OnDestroy {
    @ViewChild('visualVideoElement') visualVideoElement: ElementRef<HTMLVideoElement>;
    @ViewChild('visualCanvasElement') visualCanvasElement: ElementRef<HTMLCanvasElement>;

    public isSessionActive: boolean = false;
    public isRecording: boolean = false;
    public isDetailOpen: boolean = false;
    public speechSupported: boolean = false;
    public speechStatus: string = "대기 중";
    public backendStatus: string = "모델 연결 전";
    public diarizationMode: string = "확인 중";
    public ragInput: string = "";
    public ragResult: any = null;
    public selectedSource: any = null;
    public isGeneratingRag: boolean = false;
    public autoConversationSummary: any = null;
    public autoSummaryStatus: string = "사건 이해 대기";
    public autoSummaryMode: string = "local-llm";
    public isAutoSummarizing: boolean = false;
    public autoMediationEnabled: boolean = true;
    public autoTriggerStatus: string = "자동 중재 트리거 대기";
    public isRunningQualityCheck: boolean = false;
    public qualityResult: any = null;
    public qualityMode: string = "quick";
    public activeAssistPanel: string = "signals";
    public isVisualCameraOn: boolean = false;
    public visualStatus: string = "카메라 대기";
    public visualFaces: any[] = [];
    public visualFaceCount: number = 0;
    public visualInferMs: number = 0;
    public visualSummary: any = {
        level: "대기",
        score: 0,
        signals: []
    };
    public visualLog: any[] = [];
    public visualMeta: any = null;
    public modelReadiness: ModelReadiness = {
        whisper: false,
        silero: false,
        pyannote: false,
        textAnalysis: false,
        textWarmupMs: 0,
        rag: false,
        ragMethod: "확인 중",
        ragSourceCount: 0,
        ragChunkCount: 0,
        llm: false,
        llmStatus: "확인 중",
        visual: false,
        visualStatus: "확인 중"
    };
    public selectedSpeaker: string = "참여자 1";
    public speakerOptions: string[] = ["참여자 1", "참여자 2", "참여자 3", "참여자 4", "참여자 5", "조정자", "확인 필요"];
    public selectedWhisperModel: string = "hf-medium";
    public demoText: string = "계약한 날짜가 지났는데 아직 환불을 못 받았습니다.";
    public latestAudioTimings: any = null;
    public latestTextAnalysisTimings: any = null;

    public transcriptRows: TranscriptRow[] = [];
    public audioChunks: AudioChunkRow[] = [];
    public sessionHistory: SessionHistoryItem[] = [];
    public currentSessionId: string = "";
    public legalPipeline: LegalPipelineStep[] = [];
    public legalPipelineTerms: string[] = [];
    public stages: PipelineStage[] = [];
    public stack: any[] = [];
    public safeguards: string[] = [];
    public conflictSummary: any = {
        tension: 0,
        topic: "대기 중",
        recommendation: "마이크를 시작하거나 테스트 발화를 입력하세요.",
        risks: [],
        metrics: {
            toxicity: 0,
            emotion: { label: "중립", score: 0, source: "none" },
            lexicon_score: 0,
            topic_confidence: 0,
            topic_method: "대기 중",
            dominance_gap: 0,
            silence_gap: null,
            speaker_stats: {},
            issue_clusters: []
        }
    };

    private stream: MediaStream | null = null;
    private visualStream: MediaStream | null = null;
    private mediaRecorder: MediaRecorder | null = null;
    private visualInterval: any = null;
    private autoSummaryTimer: any = null;
    private lastAutoSummarySignature: string = "";
    private lastAutoRagInput: string = "";
    private lastAutoMediationSignature: string = "";
    private readonly autoMediationSilenceMs: number = 10000;
    private readonly sessionStorageKey: string = "prototype5_session_history_v1";
    private visualTracks: any[] = [];
    private recognition: any = null;
    private chunkIndex: number = 0;
    private turnIndex: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    private async showNotice(title: string, message: string) {
        const alertService = (this.service as any)?.alert;
        if (alertService && typeof alertService.show === "function") {
            await alertService.show({ title, message });
            return;
        }
        if (typeof window !== "undefined" && typeof window.alert === "function") {
            window.alert(`${title}\n${message}`);
            return;
        }
        console.warn(`${title}: ${message}`);
    }

    public async ngOnInit() {
        await this.service.init();
        this.initPlan();
        this.loadSessionHistoryFromStorage();
        this.ensureCurrentSession();
        this.speechSupported = !!((window as any).SpeechRecognition || (window as any).webkitSpeechRecognition);
        await this.checkModels();
        await this.service.render();
    }

    public async ngOnDestroy() {
        if (this.autoSummaryTimer) {
            clearTimeout(this.autoSummaryTimer);
            this.autoSummaryTimer = null;
        }
        await this.stopSession();
        await this.stopVisualCamera();
    }

    public async startSession() {
        if (this.isSessionActive) return;
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: false });
            this.isSessionActive = true;
            this.backendStatus = "오디오 청크 수집 중";
            this.startRecorder();
            this.startSpeechRecognition();
        } catch (err) {
            console.error(err);
            await this.showNotice('오류', '마이크 접근에 실패했습니다.');
        }
        await this.service.render();
    }

    public async stopSession() {
        if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
            this.mediaRecorder.stop();
        }
        this.mediaRecorder = null;

        if (this.recognition) {
            try { this.recognition.stop(); } catch (e) { }
            this.recognition = null;
        }

        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }

        this.isSessionActive = false;
        this.isRecording = false;
        this.speechStatus = "중지됨";
        this.backendStatus = "세션 중지";
        await this.service.render();
    }

    public async analyzeDemoText() {
        const text = (this.demoText || "").trim();
        if (!text) return;
        this.demoText = "";
        await this.addTranscript(text, "TEXT_INPUT");
    }

    public async handleDemoKeydown(event: KeyboardEvent) {
        if (event.key !== "Enter" || event.shiftKey) return;
        event.preventDefault();
        await this.analyzeDemoText();
        await this.service.render();
    }

    public async clearSession() {
        this.persistCurrentSessionHistory();
        if (this.autoSummaryTimer) {
            clearTimeout(this.autoSummaryTimer);
            this.autoSummaryTimer = null;
        }
        this.currentSessionId = this.newSessionId();
        this.resetSessionState();
        await this.service.render();
    }

    public sessionSubtitle(item: SessionHistoryItem) {
        const preview = this.cleanStatementText(item?.preview || "", 38);
        if (preview) return preview;
        return `대화 ${item?.turnCount || 0}개`;
    }

    public async openSession(item: SessionHistoryItem) {
        if (!item) return;
        this.persistCurrentSessionHistory();
        this.currentSessionId = item.id;
        this.transcriptRows = Array.isArray(item.transcriptRows) ? [...item.transcriptRows] : [];
        this.audioChunks = Array.isArray(item.audioChunks) ? [...item.audioChunks] : [];
        this.autoConversationSummary = item.autoConversationSummary || null;
        this.ragInput = item.ragInput || "";
        this.ragResult = item.ragResult || null;
        this.conflictSummary = item.conflictSummary || this.emptyConflictSummary();
        this.latestAudioTimings = item.latestAudioTimings || null;
        this.latestTextAnalysisTimings = item.latestTextAnalysisTimings || null;
        this.selectedSource = this.ragResult?.rag?.results?.[0] || null;
        this.autoSummaryStatus = this.autoConversationSummary ? "저장된 사건 이해 불러옴" : "사건 이해 대기";
        this.autoTriggerStatus = this.ragResult ? "저장된 중재안 불러옴" : "자동 중재 트리거 대기";
        this.turnIndex = this.transcriptRows.reduce((max, row) => Math.max(max, Number(row?.id || 0)), 0);
        this.chunkIndex = this.audioChunks.reduce((max, row) => Math.max(max, Number(row?.index || 0)), 0);
        this.lastAutoSummarySignature = this.conversationSignature();
        await this.service.render();
    }

    public async deleteSession(item: SessionHistoryItem, event?: Event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!item) return;
        const deletingCurrent = item.id === this.currentSessionId;
        this.sessionHistory = this.sessionHistory.filter((session) => session.id !== item.id);
        this.saveSessionHistoryToStorage();

        if (!deletingCurrent) {
            await this.service.render();
            return;
        }

        const next = this.sessionHistory[0];
        if (next) {
            await this.openSession(next);
            return;
        }

        this.currentSessionId = this.newSessionId();
        this.resetSessionState();
        await this.service.render();
    }

    public async openDetail() {
        this.isDetailOpen = true;
        await this.service.render();
    }

    public async closeDetail() {
        this.isDetailOpen = false;
        await this.service.render();
    }

    public fmtPct(value: number) {
        return `${Math.round((value || 0) * 100)}%`;
    }

    public transcriptMetaLabel(row: TranscriptRow) {
        const speaker = row?.refinedSpeaker || "참여자";
        return `${row?.time || ""} · ${speaker}`.trim();
    }

    public friendlyAutoSummaryStatus() {
        if (this.isAutoSummarizing) return "대화를 읽고 핵심 쟁점을 정리하고 있습니다.";
        if (!this.transcriptRows.length) return "대화가 쌓이면 자동으로 사건을 요약합니다.";
        if (this.autoConversationSummary) return "대화 흐름과 확인할 사실을 자동으로 정리했습니다.";
        if ((this.autoSummaryStatus || "").includes("실패")) return "자동 요약이 지연되어 기본 요약을 사용 중입니다.";
        return "대화가 멈추면 자동으로 사건을 요약합니다.";
    }

    public friendlyMediationStatus() {
        if (this.isGeneratingRag) return "관련 근거를 확인하며 해결 방향을 정리하고 있습니다.";
        if (!this.ragResult) return "대화와 근거를 바탕으로 중재 초안을 만듭니다.";
        if (this.ragResult?.status === "error") return "생성 중 문제가 있어 다시 시도할 수 있습니다.";
        const llmStatus = String(this.ragResult?.llm?.status || "");
        if (llmStatus.includes("fallback")) return "현재 확인된 근거를 바탕으로 초안을 정리했습니다.";
        if (this.ragResult?.status === "blocked") return "근거 확인이 더 필요해 기본 초안만 표시했습니다.";
        return "관련 근거를 바탕으로 중재 초안을 정리했습니다.";
    }

    public friendlySpeakerSource(source: string) {
        const key = String(source || "").toUpperCase();
        if (key === "TEXT_INPUT") return "직접 입력";
        if (key === "SERVER_STT") return "서버 전사";
        if (key === "BROWSER_STT") return "브라우저 전사";
        if (key === "ERROR") return "분석 오류";
        return "";
    }

    public tensionLabel(value: number) {
        if (value >= 0.72) return "높음";
        if (value >= 0.40) return "주의";
        return "낮음";
    }

    public tensionClass(value: number) {
        if (value >= 0.72) return "text-rose-600";
        if (value >= 0.40) return "text-amber-600";
        return "text-emerald-600";
    }

    public async setAssistPanel(panel: string) {
        this.activeAssistPanel = panel;
        await this.service.render();
    }

    public assistTabClass(panel: string) {
        const active = this.activeAssistPanel === panel;
        return active
            ? "px-3 py-2 text-xs font-black border-b-2 border-slate-900 text-slate-900"
            : "px-3 py-2 text-xs font-bold border-b-2 border-transparent text-slate-500 hover:text-slate-900";
    }

    public domainLabel(domain: string) {
        const labels: any = {
            civil: "민사",
            criminal: "형사",
            admin: "행정",
            ip: "지식재산권",
            general: "일반",
            family_registration: "가족관계등록",
            personal_rehabilitation: "개인회생",
            inheritance_will: "상속과 유언",
            housing_commercial_lease: "주택·상가임대차",
            bankruptcy_discharge: "파산면책",
            kinship: "친족",
            contract: "계약",
            property_rights: "물권",
            civil_litigation: "민사소송",
            civil_general: "민사일반",
            tort: "불법행위",
            obligation_claim: "채권"
        };
        return labels[domain] || domain || "미분류";
    }

    public qualityRows() {
        return this.qualityResult?.cases || [];
    }

    public qualityDomainRows() {
        const domainBuckets = this.qualityResult?.summary?.by_expected_domain || {};
        const typeBuckets = this.qualityResult?.summary?.by_expected_type || {};
        const buckets = Object.keys(domainBuckets).length ? domainBuckets : typeBuckets;
        return Object.keys(buckets).map((domain) => ({
            domain,
            label: this.domainLabel(domain),
            total: buckets[domain]?.total || 0,
            passed: buckets[domain]?.passed || 0
        }));
    }

    public qualityPassRate() {
        const summary = this.qualityResult?.summary || {};
        const total = Number(summary.scenario_count || 0);
        if (!total) return "0%";
        return `${Math.round(Number(summary.passed || 0) / total * 100)}%`;
    }

    public qualityGradeClass(grade: string) {
        if (grade === "pass") return "bg-emerald-50 text-emerald-700";
        if (grade === "warn") return "bg-amber-50 text-amber-700";
        if (grade === "fail") return "bg-rose-50 text-rose-700";
        return "bg-slate-50 text-slate-700";
    }

    public qualityGradeLabel(grade: string) {
        const labels: any = {
            pass: "통과",
            warn: "주의",
            fail: "실패"
        };
        return labels[grade] || grade || "확인";
    }

    public evidenceTitleLine(items: any[] = []) {
        return (items || [])
            .map((item) => item?.title || item?.case_id || item?.source_type || "")
            .filter((title) => !!title)
            .slice(0, 3)
            .join(" / ");
    }

    private compactDisplayText(value: any, maxLength: number = 220) {
        let text = String(value || "")
            .replace(/\s+/g, " ")
            .replace(/[“”]/g, "\"")
            .trim();
        if (!text) return "";
        if (text.length > maxLength) {
            text = `${text.slice(0, maxLength).trim()}...`;
        }
        return text;
    }

    private repairCommonSpacing(text: string) {
        return String(text || "")
            .replace(/다\s+루/g, "다루")
            .replace(/표\s+현/g, "표현")
            .replace(/나\s+쁘/g, "나쁘")
            .replace(/재점\s+검/g, "재점검")
            .replace(/시\s+킨/g, "시킨")
            .replace(/우\s+선/g, "우선")
            .replace(/절\s+반/g, "절반")
            .replace(/의\s+사/g, "의사")
            .replace(/관\s+계/g, "관계")
            .replace(/기\s+여/g, "기여")
            .replace(/\s+([,.;:!?])/g, "$1")
            .replace(/\(\s+/g, "(")
            .replace(/\s+\)/g, ")")
            .replace(/\.{3,}/g, "…")
            .replace(/,\s*다\./g, "다.")
            .replace(/\s+/g, " ")
            .trim();
    }

    private cleanNarrativeText(value: any, maxLength: number = 220) {
        let text = this.repairCommonSpacing(String(value || "").trim());
        if (!text) return "";
        if (text.includes("…") || /\.\.\./.test(text) || /"\s*"/.test(text)) {
            return "";
        }
        text = text.replace(/^[,:;\-]+/, "").trim();
        if (text.length > maxLength) {
            const sentenceCut = text.slice(0, maxLength).match(/^(.{40,}?[.!?]|.{40,}?다\.)/);
            if (sentenceCut && sentenceCut[1]) {
                text = sentenceCut[1].trim();
            } else {
                text = "";
            }
        }
        return text;
    }

    private splitListItems(items: any[]) {
        const results: string[] = [];
        for (const item of items || []) {
            const raw = String(item || "").trim();
            if (!raw) continue;
            const parts = raw
                .split(/\s*[,\u00b7\/]\s*/g)
                .map((part) => this.repairCommonSpacing(part))
                .map((part) => part.replace(/^-\s*/, "").trim())
                .filter(Boolean);
            if (parts.length >= 2) {
                results.push(...parts);
            } else {
                results.push(this.repairCommonSpacing(raw));
            }
        }
        return results;
    }

    private isGenericIssueLabel(text: string) {
        const value = String(text || "").trim();
        if (!value) return true;
        return [
            "대기 중",
            "갈등 요약",
            "일상 대화 갈등",
            "관계와 의사소통 방식",
            "감정과 의사소통 방식",
            "감정과 의사소통",
            "대화 정리",
            "대화 세션",
        ].includes(value);
    }

    private cleanChecklistText(value: any) {
        let text = this.repairCommonSpacing(this.compactDisplayText(value, 140));
        if (!text) return "";
        text = text
            .replace(/^확인\s*(항목|할 사실)\s*:\s*/i, "")
            .replace(/^질문\s*:\s*/i, "")
            .replace(/준비 여부가 확인되었나요\?$/g, "")
            .replace(/여부가 확인되었나요\?$/g, "")
            .replace(/확인되었나요\?$/g, "")
            .replace(/확인 필요 여부$/g, "확인 필요")
            .replace(/준비 여부$/g, "")
            .replace(/\s+/g, " ")
            .trim();
        return text;
    }

    private cleanQuestionText(value: any) {
        let text = this.repairCommonSpacing(this.compactDisplayText(value, 220));
        if (!text) return "";
        text = text.replace(/\s+/g, " ").trim();
        text = text.replace(/^["']+|["']+$/g, "").trim();
        if (!/[?？]$/.test(text) && text.length < 100) {
            text = `${text}?`;
        }
        return text;
    }

    private cleanStatementText(value: any, maxLength: number = 180) {
        return this.repairCommonSpacing(this.compactDisplayText(value, maxLength));
    }

    private dedupeDisplayItems(items: any[], cleaner: (value: any) => string, limit: number = 6) {
        const seen = new Set<string>();
        const output: string[] = [];
        for (const item of items || []) {
            const cleaned = cleaner(item);
            const key = cleaned.toLowerCase();
            if (!cleaned || seen.has(key)) continue;
            seen.add(key);
            output.push(cleaned);
            if (output.length >= limit) break;
        }
        return output;
    }

    public mediationSummaryLines() {
        const generated = this.ragResult?.generated || {};
        const concise = this.dedupeDisplayItems(
            generated?.concise_answer || [],
            (item) => this.cleanNarrativeText(item, 180),
            2
        );
        if (concise.length) return concise;
        const neutral = this.cleanNarrativeText(generated?.neutral_reframe, 200);
        const proposal = this.cleanNarrativeText(generated?.settlement_proposal?.summary, 200);
        const fallback = "현재는 확인 가능한 사실과 필요한 절차를 먼저 정리해야 하는 조정 사안입니다.";
        return [neutral || proposal || fallback].filter(Boolean);
    }

    public mediationParticipantLines() {
        return this.dedupeDisplayItems(
            this.ragResult?.generated?.participant_positions || [],
            (item) => this.cleanStatementText(item, 160),
            5
        );
    }

    public mediationCommonGroundLines() {
        return this.dedupeDisplayItems(
            this.ragResult?.generated?.common_ground || [],
            (item) => this.cleanStatementText(item, 120),
            4
        );
    }

    public mediationActionLines() {
        return this.dedupeDisplayItems(
            this.ragResult?.generated?.negotiable_actions || [],
            (item) => this.cleanStatementText(item, 150),
            5
        );
    }

    public mediationQuestionLines() {
        const generated = this.dedupeDisplayItems(
            this.ragResult?.generated?.mediator_questions || this.ragResult?.generated?.questions || [],
            (item) => this.cleanQuestionText(item),
            6
        ).filter((item) => this.isUsableMediationQuestion(item));
        if (generated.length >= 2) return generated.slice(0, 4);
        return this.fallbackMediationQuestions();
    }

    public mediationFactLines() {
        return this.dedupeDisplayItems(
            this.splitListItems(this.ragResult?.generated?.facts_to_check || []),
            (item) => this.cleanChecklistText(item),
            6
        );
    }

    public autoSummaryFactLines() {
        return this.dedupeDisplayItems(
            this.splitListItems(this.autoConversationSummary?.facts_to_check || []),
            (item) => this.cleanChecklistText(item),
            5
        );
    }

    public ragSources() {
        return this.ragResult?.rag?.results || [];
    }

    public sourceDisplayTitle(item: any) {
        if (!item) return "근거";
        const title = this.cleanStatementText(item.title || "", 120);
        if (title) return title;
        const path = String(item.path || "").split("/").pop() || "";
        return path || item.source_label || item.source_type || "근거";
    }

    public sourceDisplayMeta(item: any) {
        if (!item) return "";
        const parts = [
            item.source_label || item.source_type || "",
            item.reason || "",
        ].filter(Boolean);
        return this.cleanStatementText(parts.join(" · "), 160);
    }

    public sourceDisplayExcerpt(item: any) {
        if (!item) return "";
        return this.cleanStatementText(item.excerpt || "", 520);
    }

    public async selectSource(item: any) {
        this.selectedSource = item;
        await this.service.render();
    }

    private isUsableMediationQuestion(text: string) {
        const value = String(text || "").trim();
        if (!value) return false;
        if (value.length < 8 || value.length > 140) return false;
        if ((value.match(/\?/g) || []).length > 1) return false;
        if (/["“”']/.test(value)) return false;
        if (/오늘 대화의 목적은|좋습니다\.|그렇다면 핵심 쟁점은|누가 더|대상자\s*\d|표 현|나 쁘다|있습\?|정리하면/.test(value)) return false;
        if (!/[가-힣]/.test(value)) return false;
        return true;
    }

    private fallbackMediationQuestions() {
        const facts = this.mediationFactLines();
        const coreIssue = this.cleanStatementText(
            this.ragResult?.generated?.settlement_proposal?.core_issue
            || this.autoConversationSummary?.core_issue
            || this.conflictSummary?.topic,
            50
        );
        const questions = [
            coreIssue ? `지금 가장 먼저 확인해야 할 핵심 쟁점은 ${coreIssue} 중 무엇인가요?` : "",
            facts[0] ? `${facts[0]}부터 함께 확인해도 괜찮을까요?` : "",
            facts[1] ? `${facts[1]} 항목은 누가 언제까지 확인해 볼까요?` : "",
            "양측이 바로 합의할 수 있는 부분과 추가 확인이 필요한 부분을 나누어 볼까요?",
        ].filter(Boolean);
        return this.dedupeDisplayItems(questions, (item) => this.cleanQuestionText(item), 4);
    }

    private emptyConflictSummary() {
        return {
            tension: 0,
            topic: "대기 중",
            recommendation: "마이크를 시작하거나 테스트 발화를 입력하세요.",
            risks: [],
            metrics: {
                toxicity: 0,
                emotion: { label: "중립", score: 0, source: "none" },
                lexicon_score: 0,
                topic_confidence: 0,
                topic_method: "대기 중",
                dominance_gap: 0,
                silence_gap: null,
                speaker_stats: {},
                issue_clusters: []
            }
        };
    }

    private resetSessionState() {
        this.transcriptRows = [];
        this.audioChunks = [];
        this.latestAudioTimings = null;
        this.latestTextAnalysisTimings = null;
        this.autoConversationSummary = null;
        this.autoSummaryStatus = "사건 이해 대기";
        this.autoSummaryMode = "local-llm";
        this.isAutoSummarizing = false;
        this.autoTriggerStatus = "자동 중재 트리거 대기";
        this.ragInput = "";
        this.ragResult = null;
        this.selectedSource = null;
        this.lastAutoSummarySignature = "";
        this.lastAutoRagInput = "";
        this.lastAutoMediationSignature = "";
        this.chunkIndex = 0;
        this.turnIndex = 0;
        this.conflictSummary = this.emptyConflictSummary();
    }

    private newSessionId() {
        return `session_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    }

    private ensureCurrentSession() {
        if (!this.currentSessionId) {
            this.currentSessionId = this.newSessionId();
        }
    }

    private currentSessionHasContent() {
        return !!(
            this.transcriptRows.length ||
            (this.ragInput || "").trim() ||
            this.autoConversationSummary ||
            this.ragResult
        );
    }

    private currentSessionTitle() {
        const issueCandidates = [
            this.autoConversationSummary?.legal_issue_candidates?.[0],
            this.ragResult?.generated?.settlement_proposal?.core_issue,
            this.autoConversationSummary?.core_issue,
            this.conflictSummary?.topic,
        ]
            .map((item) => this.cleanStatementText(item, 26))
            .filter((item) => !!item && !this.isGenericIssueLabel(item));
        const issue = issueCandidates[0] || "";
        const type = this.cleanStatementText(this.autoConversationSummary?.conflict_type, 12);
        if (issue && type && issue.indexOf(type) === -1) {
            return `${type} · ${issue}`;
        }
        if (issue) return issue;
        const first = this.transcriptRows[0]?.text || this.ragInput || "새 대화";
        return this.compactDisplayText(first, 26) || "새 대화";
    }

    private currentSessionPreview() {
        const summary = this.cleanNarrativeText(
            this.autoConversationSummary?.overview
            || this.ragResult?.generated?.concise_answer?.[0]
            || this.ragResult?.generated?.settlement_proposal?.summary,
            54
        );
        if (summary) return summary;
        const recent = this.transcriptRows.slice(-1)[0]?.text || this.ragInput || "";
        return this.compactDisplayText(recent, 54);
    }

    private buildCurrentSessionSnapshot(): SessionHistoryItem {
        return {
            id: this.currentSessionId,
            title: this.currentSessionTitle(),
            preview: this.currentSessionPreview(),
            topic: this.conflictSummary?.topic || "대기 중",
            turnCount: this.transcriptRows.length,
            updatedAt: Date.now(),
            transcriptRows: [...this.transcriptRows],
            audioChunks: [...this.audioChunks],
            autoConversationSummary: this.autoConversationSummary || null,
            ragInput: this.ragInput || "",
            ragResult: this.ragResult || null,
            conflictSummary: this.conflictSummary || this.emptyConflictSummary(),
            latestAudioTimings: this.latestAudioTimings || null,
            latestTextAnalysisTimings: this.latestTextAnalysisTimings || null,
        };
    }

    private persistCurrentSessionHistory() {
        this.ensureCurrentSession();
        if (!this.currentSessionHasContent()) return;
        const snapshot = this.buildCurrentSessionSnapshot();
        const existing = this.sessionHistory.filter((item) => item.id !== snapshot.id);
        this.sessionHistory = [snapshot, ...existing].slice(0, 24);
        this.saveSessionHistoryToStorage();
    }

    private saveSessionHistoryToStorage() {
        if (typeof window === "undefined" || !window.localStorage) return;
        try {
            window.localStorage.setItem(this.sessionStorageKey, JSON.stringify(this.sessionHistory));
        } catch (e) {
            console.warn("session history save failed", e);
        }
    }

    private loadSessionHistoryFromStorage() {
        if (typeof window === "undefined" || !window.localStorage) return;
        try {
            const raw = window.localStorage.getItem(this.sessionStorageKey);
            if (!raw) {
                this.sessionHistory = [];
                return;
            }
            const parsed = JSON.parse(raw);
            this.sessionHistory = Array.isArray(parsed) ? parsed.slice(0, 24) : [];
        } catch (e) {
            console.warn("session history load failed", e);
            this.sessionHistory = [];
        }
    }

    public async runLegalQualityCheck(includeRag: boolean = false, includeMediation: boolean = false, fullGeneration: boolean = false) {
        if (this.isRunningQualityCheck) return;
        this.isRunningQualityCheck = true;
        this.qualityMode = fullGeneration ? "full" : (includeMediation ? "regression" : (includeRag ? "rag" : "quick"));
        this.activeAssistPanel = "evaluation";
        await this.service.render();

        try {
            const result = await wiz.call("evaluate_legal_quality", {
                include_rag: includeRag ? "true" : "false",
                include_mediation: includeMediation ? "true" : "false",
                full_generation: fullGeneration ? "true" : "false",
                limit: includeMediation ? 8 : 20
            });
            if (result.code === 200 && result.data) {
                this.qualityResult = result.data;
            } else {
                this.qualityResult = {
                    status: "error",
                    summary: { scenario_count: 0, passed: 0, failed: 0, elapsed_ms: 0 },
                    cases: []
                };
            }
        } catch (e) {
            console.error(e);
            this.qualityResult = {
                status: "error",
                summary: { scenario_count: 0, passed: 0, failed: 0, elapsed_ms: 0 },
                cases: []
            };
        }

        this.isRunningQualityCheck = false;
        await this.service.render();
    }

    public metricPct(path: string) {
        const value = path.split('.').reduce((acc: any, key: string) => acc ? acc[key] : 0, this.conflictSummary?.metrics || {});
        return this.fmtPct(Number(value || 0));
    }

    public speakerStatRows() {
        const stats = this.conflictSummary?.metrics?.speaker_stats || {};
        return Object.keys(stats).map((speaker) => ({
            speaker,
            turns: stats[speaker]?.turns || 0,
            chars: stats[speaker]?.chars || 0
        }));
    }

    public isRightAlignedSpeaker(speaker: string) {
        const match = String(speaker || "").match(/참여자\s*(\d+)/);
        if (!match) return false;
        return Number(match[1]) % 2 === 0;
    }

    public speakerDebugBadges(row: TranscriptRow) {
        const badges: string[] = [];
        const speaker = row?.speakerDiagnostics || {};
        if (speaker.pyannote_speaker) {
            badges.push(`화자분리 ${this.fmtPct(speaker.pyannote_confidence || speaker.pyannote_overlap_ratio || 0)}`);
        }
        const bge = speaker.bge_repair || row?.summary?.metrics?.speaker_context_repair;
        if (bge?.scores) {
            const top = Object.keys(bge.scores)
                .map(key => ({ key, value: Number(bge.scores[key] || 0) }))
                .sort((a, b) => b.value - a.value)[0];
            if (top) badges.push(`맥락보정 ${top.key} ${this.fmtPct(top.value)}`);
        }
        const sourceLabel = this.friendlySpeakerSource(speaker.source);
        if (sourceLabel) badges.push(sourceLabel);
        if (row?.timings?.turn_analysis_ms !== undefined) badges.push(`분석 ${row.timings.turn_analysis_ms}ms`);
        if (row?.merged) badges.push("청크 병합");
        return badges.slice(0, 4);
    }

    public timingRows() {
        const timings = this.latestAudioTimings || {};
        const labels: any = {
            total_ms: "전체",
            decode_ms: "디코딩",
            vad_ms: "VAD",
            stt_ms: "STT",
            diarization_ms: "화자분리",
            analysis_ms: "BGE/분석",
            cluster_ms: "음향군집"
        };
        const audioRows = Object.keys(labels)
            .filter(key => timings[key] !== undefined && timings[key] !== null)
            .map(key => ({ label: labels[key], value: timings[key] }));
        const textTimings = this.latestTextAnalysisTimings || this.conflictSummary?.metrics?.analysis_timings || {};
        const textLabels: any = {
            total_text_analysis_ms: "텍스트분석",
            lexicon_ms: "사전",
            toxic_ms: "유해모델",
            emotion_ms: "감정모델",
            topic_ms: "쟁점/BGE"
        };
        const textRows = Object.keys(textLabels)
            .filter(key => textTimings[key] !== undefined && textTimings[key] !== null)
            .map(key => ({ label: textLabels[key], value: textTimings[key] }));
        return [...audioRows, ...textRows].slice(0, 10);
    }

    public statusLabel(status: StageStatus) {
        const labels: any = {
            ready: "우선 구축",
            planned: "구축 예정",
            guarded: "제한 적용"
        };
        return labels[status] || status;
    }

    public statusClass(status: StageStatus) {
        const classes: any = {
            ready: "bg-emerald-50 text-emerald-700 border-emerald-200",
            planned: "bg-indigo-50 text-indigo-700 border-indigo-200",
            guarded: "bg-amber-50 text-amber-700 border-amber-200"
        };
        return `inline-flex items-center rounded border px-2 py-0.5 text-[11px] font-bold ${classes[status] || classes.planned}`;
    }

    public readinessText(ready: boolean) {
        return ready ? "준비됨" : "대기";
    }

    public readinessClass(ready: boolean) {
        return ready ? "text-emerald-600" : "text-amber-600";
    }

    public async checkModels() {
        try {
            const result = await wiz.call("check_models", {});
            const data = result?.data || {};
            this.modelReadiness = {
                whisper: !!data.whisper_ready,
                silero: !!data.silero_ready,
                pyannote: !!data.pyannote_ready,
                textAnalysis: !!data.text_analysis_ready,
                textWarmupMs: data.text_analysis_warmup_ms || 0,
                rag: !!data.rag_ready,
                ragMethod: data.rag_method || "확인 중",
                ragSourceCount: data.rag_source_count || 0,
                ragChunkCount: data.rag_chunk_count || 0,
                llm: !!data.llm_ready,
                llmStatus: data.llm_status || "확인 중",
                visual: !!data.visual_ready,
                visualStatus: data.visual_status || "확인 중"
            };
            this.diarizationMode = data.diarization_mode || "context-fallback";
            this.backendStatus = data.backend_status || "모델 상태 확인 완료";
        } catch (e) {
            console.error(e);
            this.backendStatus = "모델 상태 확인 실패";
            this.diarizationMode = "확인 실패";
        }
    }

    private startRecorder() {
        if (!this.stream) return;
        const options = this.pickRecorderOptions();
        this.mediaRecorder = new MediaRecorder(this.stream, options);
        this.mediaRecorder.ondataavailable = async (event: BlobEvent) => {
            if (!event.data || event.data.size === 0) return;
            await this.processAudioChunk(event.data);
        };
        this.mediaRecorder.onstart = async () => {
            this.isRecording = true;
            await this.service.render();
        };
        this.mediaRecorder.onstop = async () => {
            this.isRecording = false;
            await this.service.render();
        };
        this.mediaRecorder.start(5000);
    }

    private pickRecorderOptions(): MediaRecorderOptions {
        const candidates = [
            "audio/webm;codecs=opus",
            "audio/webm",
            "audio/mp4"
        ];
        for (const mimeType of candidates) {
            if ((window as any).MediaRecorder && MediaRecorder.isTypeSupported(mimeType)) {
                return { mimeType };
            }
        }
        return {};
    }

    private startSpeechRecognition() {
        const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
        if (!SpeechRecognition) {
            this.speechStatus = "브라우저 STT 미지원";
            return;
        }

        this.recognition = new SpeechRecognition();
        this.recognition.lang = "ko-KR";
        this.recognition.continuous = true;
        this.recognition.interimResults = false;
        this.recognition.onstart = async () => {
            this.speechStatus = "브라우저 STT 수신 중";
            await this.service.render();
        };
        this.recognition.onerror = async (event: any) => {
            this.speechStatus = `STT 오류: ${event?.error || 'unknown'}`;
            await this.service.render();
        };
        this.recognition.onend = async () => {
            if (this.isSessionActive && this.recognition) {
                try { this.recognition.start(); } catch (e) { }
            }
        };
        this.recognition.onresult = async (event: any) => {
            for (let i = event.resultIndex; i < event.results.length; i++) {
                if (!event.results[i].isFinal) continue;
                const text = event.results[i][0].transcript.trim();
                if (text) await this.addTranscript(text, "BROWSER_STT");
            }
        };

        try {
            this.recognition.start();
        } catch (e) {
            this.speechStatus = "STT 시작 실패";
        }
    }

    private async processAudioChunk(blob: Blob) {
        const index = ++this.chunkIndex;
        const row: AudioChunkRow = {
            index,
            time: new Date().toLocaleTimeString(),
            sizeKb: Math.round(blob.size / 102.4) / 10,
            mimeType: blob.type || "unknown",
            status: "전송 중"
        };
        this.audioChunks.unshift(row);
        if (this.audioChunks.length > 12) this.audioChunks.pop();
        await this.service.render();

        try {
            const audio = await this.blobToDataUrl(blob);
            const result = await wiz.call("process_audio_chunk", {
                index,
                audio,
                mime_type: blob.type || "",
                size: blob.size,
                preferred_speaker: this.selectedSpeaker,
                whisper_model: "hf-medium",
                history: JSON.stringify(this.transcriptRows.slice(-12))
            });
            row.status = result?.data?.message || "수신 완료";
            row.timings = result?.data?.timings || null;
            this.latestAudioTimings = result?.data?.timings || this.latestAudioTimings;
            this.backendStatus = result?.data?.backend_status || "청크 수신";
            this.diarizationMode = result?.data?.diarization_mode || this.diarizationMode;
            this.appendServerTurns(result?.data?.turns || []);
        } catch (e) {
            console.error(e);
            row.status = "전송 실패";
            this.backendStatus = "청크 처리 실패";
        }
        await this.service.render();
    }

    private appendServerTurns(turns: any[]) {
        if (!turns || turns.length === 0) return;

        turns.forEach((turn) => {
            this.turnIndex += 1;
            const row: TranscriptRow = {
                id: this.turnIndex,
                time: new Date().toLocaleTimeString(),
                rawSpeaker: turn.raw_speaker || "SERVER_STT",
                refinedSpeaker: turn.refined_speaker || this.selectedSpeaker,
                confidence: turn.confidence || 0.5,
                text: turn.text || "",
                signal: turn.signal || "전사 완료",
                tension: turn.tension || 0,
                start: turn.start,
                end: turn.end,
                summary: turn.summary,
                diagnostics: turn.diagnostics,
                speakerDiagnostics: turn.speaker_diagnostics,
                timings: turn.timings
            };
            if (this.tryMergeBoundaryTurn(row)) {
                if (turn.summary) this.refreshConversationSummary(turn.summary);
                return;
            }
            this.transcriptRows.push(row);
            if (turn.summary) this.refreshConversationSummary(turn.summary);
        });

        if (this.transcriptRows.length > 40) {
            this.transcriptRows = this.transcriptRows.slice(-40);
        }
        this.persistCurrentSessionHistory();
        this.scheduleAutoConversationSummary();
    }

    private tryMergeBoundaryTurn(row: TranscriptRow) {
        const previous = this.transcriptRows[this.transcriptRows.length - 1];
        if (!previous || !row) return false;
        if (previous.refinedSpeaker !== row.refinedSpeaker) return false;
        if (!previous.text || !row.text) return false;

        const previousLooksOpen = !/[.!?。！？…]$/.test(previous.text.trim()) || previous.text.trim().length < 24;
        const startsNearBoundary = row.start === undefined || Number(row.start || 0) <= 1.4;
        if (!previousLooksOpen || !startsNearBoundary) return false;

        previous.text = `${previous.text.trim()} ${row.text.trim()}`.trim();
        previous.end = row.end;
        previous.confidence = Math.max(previous.confidence || 0, row.confidence || 0);
        previous.tension = Math.max(previous.tension || 0, row.tension || 0);
        previous.signal = row.signal || previous.signal;
        previous.summary = row.summary || previous.summary;
        previous.diagnostics = row.diagnostics || previous.diagnostics;
        previous.speakerDiagnostics = row.speakerDiagnostics || previous.speakerDiagnostics;
        previous.timings = row.timings || previous.timings;
        previous.merged = true;
        return true;
    }

    private async addTranscript(text: string, source: string): Promise<boolean> {
        this.turnIndex += 1;
        const row: TranscriptRow = {
            id: this.turnIndex,
            time: new Date().toLocaleTimeString(),
            rawSpeaker: source || "TEXT_INPUT",
            refinedSpeaker: this.selectedSpeaker,
            confidence: 0.35,
            text,
            signal: "분석 중",
            tension: 0
        };
        this.transcriptRows.push(row);
        if (this.transcriptRows.length > 40) this.transcriptRows = this.transcriptRows.slice(-40);
        await this.service.render();

        try {
            const result = await wiz.call("analyze_text_turn", {
                text,
                source,
                turn_index: row.id,
                preferred_speaker: this.selectedSpeaker,
                history: JSON.stringify(this.transcriptRows.slice(-12))
            });

            if (result.code === 200 && result.data) {
                const data = result.data;
                row.rawSpeaker = data.raw_speaker || row.rawSpeaker || "UNKNOWN";
                row.refinedSpeaker = data.refined_speaker || row.refinedSpeaker || this.selectedSpeaker;
                row.confidence = data.confidence || 0.5;
                row.signal = data.signal || "분석 완료";
                row.tension = data.tension || 0;
                row.summary = data.summary;
                row.diagnostics = data.diagnostics;
                row.timings = data.timings;
                this.latestTextAnalysisTimings = data.timings || data.summary?.metrics?.analysis_timings || this.latestTextAnalysisTimings;
                this.refreshConversationSummary(data.summary || this.conflictSummary);
                this.scheduleAutoConversationSummary();
            }
        } catch (e) {
            console.error(e);
            row.rawSpeaker = "ERROR";
            row.refinedSpeaker = "확인 필요";
            row.confidence = 0;
            row.signal = "분석 실패";
            row.tension = 0;
        }
        if (this.transcriptRows.length > 40) this.transcriptRows = this.transcriptRows.slice(-40);
        this.persistCurrentSessionHistory();
        await this.service.render();
        return true;
    }

    private refreshConversationSummary(latestSummary: any) {
        const summaries = this.transcriptRows
            .map(row => row.summary)
            .filter(summary => !!summary);
        const activeSummaries = summaries.length ? summaries : [latestSummary];
        const highest = activeSummaries.reduce((best, summary) => {
            return (Number(summary?.tension || 0) > Number(best?.tension || 0)) ? summary : best;
        }, latestSummary || {});

        const risks: string[] = [];
        activeSummaries.forEach(summary => {
            (summary?.risks || []).forEach((risk: string) => {
                if (risk && risk !== "명시적 고위험 표현 없음" && risks.indexOf(risk) === -1) {
                    risks.push(risk);
                }
            });
        });

        let tension = Math.max(
            Number(latestSummary?.tension || 0),
            Number(highest?.tension || 0)
        );
        if (risks.length >= 3 && tension < 0.40) {
            tension = 0.40;
        }

        let recommendation = latestSummary?.recommendation || highest?.recommendation || "현재 대화를 계속 관찰하세요.";
        if (tension >= 0.72) {
            recommendation = "대화 전체에서 고위험 신호가 감지되었습니다. 발화를 잠시 멈추고 사실관계, 감정, 요구사항을 분리해 확인하세요.";
        } else if (tension >= 0.40 || risks.length >= 3) {
            recommendation = "대화 전체에서 주의 신호가 감지되었습니다. 대기 사유, 절차, 요구사항을 짧고 구체적으로 확인하세요.";
        }

        this.conflictSummary = {
            ...(latestSummary || {}),
            tension,
            topic: highest?.topic || latestSummary?.topic || "대기 중",
            recommendation,
            risks: risks.length ? risks.slice(0, 6) : (latestSummary?.risks || ["명시적 고위험 표현 없음"]),
            metrics: latestSummary?.metrics || highest?.metrics || this.conflictSummary.metrics,
            model_status: latestSummary?.model_status || highest?.model_status
        };
        this.persistCurrentSessionHistory();
    }

    private conversationSignature() {
        return this.transcriptRows
            .slice(-16)
            .map(row => `${row.refinedSpeaker}:${row.text}`)
            .join("|")
            .slice(0, 3200);
    }

    private recentConversationQuery() {
        return this.transcriptRows
            .slice(-16)
            .map(row => {
                const speaker = row.refinedSpeaker || row.rawSpeaker || "참여자";
                return `${speaker}: ${row.text}`;
            })
            .join("\n")
            .trim()
            .slice(0, 5000);
    }

    private hasUrgentLegalRisk() {
        const risks = (this.conflictSummary?.risks || []).join(" ");
        const recentText = this.transcriptRows.slice(-8).map(row => row.text).join(" ");
        const text = `${risks} ${recentText}`;
        return /(협박|폭행|상해|흉기|죽|가만 안|고소|고발|경찰|스토킹|성범죄|불법촬영|재물손괴)/.test(text);
    }

    private evaluateAutoMediationTrigger(source: string = "analysis") {
        if (!this.autoMediationEnabled || this.transcriptRows.length === 0) return;
        const tension = Number(this.conflictSummary?.tension || 0);
        const risks = this.conflictSummary?.risks || [];
        const urgent = this.hasUrgentLegalRisk();

        if (tension >= 0.72 || urgent) {
            const reason = urgent ? "안전/법적 위험" : "고긴장";
            this.autoTriggerStatus = `${reason} 감지 · 10초 무발화 후 LLM 사건 이해 예정`;
            this.activeAssistPanel = "mediation";
            return;
        }

        if (tension >= 0.40 || risks.length >= 3) {
            this.autoTriggerStatus = "주의 신호 감지 · 10초 무발화 후 상담 코치 답변 준비";
            this.activeAssistPanel = "mediation";
            return;
        }

        this.autoTriggerStatus = source === "summary" ? "LLM 사건 이해 완료" : "10초 무발화 자동 중재 대기";
    }

    private scheduleAutoConversationSummary() {
        if (this.transcriptRows.length === 0) return;
        const signature = this.conversationSignature();
        this.autoSummaryStatus = "10초 무발화 후 LLM 사건 이해 예정";
        this.evaluateAutoMediationTrigger("analysis");
        if (this.autoSummaryTimer) clearTimeout(this.autoSummaryTimer);
        this.autoSummaryTimer = setTimeout(async () => {
            if (!this.autoMediationEnabled) {
                this.autoSummaryStatus = "자동 중재 트리거 꺼짐";
                await this.service.render();
                return;
            }
            if (signature !== this.conversationSignature() || this.isGeneratingRag) return;
            const silenceSignature = `silence:${signature}`;
            if (silenceSignature === this.lastAutoMediationSignature) return;
            this.lastAutoMediationSignature = silenceSignature;
            this.autoSummaryStatus = "10초 무발화 감지 · LLM 사건 이해 중";
            this.autoTriggerStatus = "LLM 사건 이해 + ADR RAG 자동 생성 중";
            this.activeAssistPanel = "mediation";
            await this.service.render();
            await this.generateMediationSupport("silence-gap");
        }, this.autoMediationSilenceMs);
    }

    public async refreshAutoConversationSummary(force: boolean = true) {
        if (this.transcriptRows.length === 0 || this.isAutoSummarizing) return;
        const signature = this.conversationSignature();
        if (!force && signature === this.lastAutoSummarySignature) return;
        this.lastAutoSummarySignature = signature;
        this.isAutoSummarizing = true;
        this.autoSummaryStatus = force ? "로컬 LLM 사건 요약 중" : "빠른 사건 요약 중";
        await this.service.render();

        try {
            const result = await wiz.call("summarize_conversation", {
                history: JSON.stringify(this.transcriptRows.slice(-16)),
                conflict_summary: JSON.stringify(this.conflictSummary || {}),
                fast_only: !force
            });
            if (result.code === 200 && result.data) {
                const data = result.data;
                this.autoConversationSummary = data.summary || null;
                this.autoSummaryMode = data.mode || this.autoConversationSummary?.mode || "local-llm";
                this.autoSummaryStatus = `${this.autoSummaryMode} · ${data.llm?.status || '요약 완료'} · ${data.elapsed_ms || 0}ms`;
                const nextInput = (this.autoConversationSummary?.mediation_query || this.autoConversationSummary?.overview || "").trim();
                if (nextInput && (!this.ragInput.trim() || this.ragInput === this.lastAutoRagInput)) {
                    this.ragInput = nextInput;
                    this.lastAutoRagInput = nextInput;
                }
                this.evaluateAutoMediationTrigger("summary");
                this.persistCurrentSessionHistory();
            }
        } catch (e) {
            console.warn("summarize_conversation failed");
            this.autoSummaryStatus = force ? "로컬 LLM 사건 요약 실패" : "빠른 사건 요약 실패";
        }

        this.isAutoSummarizing = false;
        await this.service.render();
    }

    public async generateMediationSupport(trigger: string = "manual") {
        const isAutomatic = trigger === "auto-trigger" || trigger === "silence-gap";
        const transcriptQuery = this.recentConversationQuery();
        let query = isAutomatic
            ? transcriptQuery
            : (this.ragInput || transcriptQuery || this.autoConversationSummary?.mediation_query || this.autoConversationSummary?.overview || "").trim();
        if (!query && this.transcriptRows.length > 0 && !this.isAutoSummarizing) {
            await this.refreshAutoConversationSummary(true);
            query = (this.ragInput || transcriptQuery || this.autoConversationSummary?.mediation_query || this.autoConversationSummary?.overview || "").trim();
        }
        if (!query.trim()) {
            await this.showNotice('안내', '중재안을 생성할 대화나 사건 설명이 필요합니다. 대화를 입력한 뒤 10초 기다리거나 직접 설명을 입력해 주세요.');
            return;
        }

        this.isGeneratingRag = true;
        if (isAutomatic) {
            this.autoTriggerStatus = "LLM 사건 이해 + ADR RAG 자동 생성 중";
            this.autoSummaryStatus = "LLM 사건 이해 중";
        }
        await this.service.render();

        try {
            const result = await wiz.call("generate_mediation_support", {
                query,
                history: JSON.stringify(this.transcriptRows.slice(-16)),
                top_k: 5,
                use_llm: true,
                use_bge: false,
                require_case_llm: true
            });
            if (result.code === 200 && result.data) {
                this.ragResult = result.data;
                const sources = result.data?.rag?.results || [];
                this.selectedSource = sources.length ? sources[0] : null;
                if (result.data.status === "blocked") {
                    const mode = result.data?.llm?.mode || "";
                    this.autoTriggerStatus = mode === "llm-rag-grounded-required"
                        ? "RAG 근거 기반 LLM 중재안 생성 필요"
                        : "LLM 사건 이해 설정 필요";
                } else {
                    this.autoTriggerStatus = isAutomatic ? "10초 무발화 자동 중재안 생성 완료" : "수동 중재안 생성 완료";
                    if (isAutomatic) {
                        this.autoSummaryStatus = "LLM 사건 이해 + 상담 코치 답변 완료";
                    }
                }
                this.persistCurrentSessionHistory();
            }
        } catch (e) {
            console.error(e);
            this.autoTriggerStatus = isAutomatic ? "자동 중재안 생성 실패" : this.autoTriggerStatus;
            this.ragResult = {
                status: "error",
                generated: {
                    concise_answer: ["중재 보조 생성 중 오류가 발생했습니다. 잠시 후 다시 생성하거나 입력 내용을 조금 짧게 줄여 다시 시도해 주세요."],
                    notice: "중재 보조 생성 중 오류가 발생했습니다."
                },
                rag: {
                    results: []
                }
            };
            this.selectedSource = null;
            this.persistCurrentSessionHistory();
        }

        this.isGeneratingRag = false;
        await this.service.render();
    }

    public async startVisualCamera() {
        try {
            this.visualStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            this.visualVideoElement.nativeElement.srcObject = this.visualStream;
            this.isVisualCameraOn = true;
            this.visualStatus = "분석 준비 중";
            this.visualVideoElement.nativeElement.onloadedmetadata = () => {
                this.syncVisualCanvasSize();
                this.startVisualAnalysis();
            };
        } catch (err) {
            console.error(err);
            await this.showNotice('오류', '카메라 접근에 실패했습니다.');
        }
        await this.service.render();
    }

    public async stopVisualCamera() {
        if (this.visualInterval) {
            clearInterval(this.visualInterval);
            this.visualInterval = null;
        }
        if (this.visualStream) {
            this.visualStream.getTracks().forEach(track => track.stop());
            this.visualStream = null;
        }
        if (this.visualVideoElement) this.visualVideoElement.nativeElement.srcObject = null;
        if (this.visualCanvasElement) {
            const ctx = this.visualCanvasElement.nativeElement.getContext('2d');
            if (ctx) ctx.clearRect(0, 0, this.visualCanvasElement.nativeElement.width, this.visualCanvasElement.nativeElement.height);
        }
        this.isVisualCameraOn = false;
        this.visualFaces = [];
        this.visualFaceCount = 0;
        this.visualTracks = [];
        this.visualStatus = "카메라 대기";
        await this.service.render();
    }

    private startVisualAnalysis() {
        if (this.visualInterval) clearInterval(this.visualInterval);
        this.visualInterval = setInterval(() => {
            this.captureVisualFrame();
        }, 700);
    }

    private async captureVisualFrame() {
        const video = this.visualVideoElement?.nativeElement;
        if (!video || video.videoWidth === 0 || video.videoHeight === 0) return;

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const image = canvas.toDataURL('image/jpeg', 0.78);

        try {
            const resultInfo = await wiz.call("process_visual_frame", {
                image,
                tracks: JSON.stringify(this.visualTracks)
            });
            const data = resultInfo?.data || {};
            if (resultInfo.code === 200 && data.status === "success") {
                this.visualMeta = data.meta;
                this.visualFaces = data.faces || [];
                this.visualFaceCount = data.face_count || 0;
                this.visualInferMs = data.infer_ms || 0;
                this.visualTracks = data.tracks || [];
                this.visualSummary = data.summary || this.visualSummary;
                this.visualStatus = this.visualFaceCount > 0 ? `${this.visualFaceCount}명 표정 후보 분석` : "얼굴 미검출";
                this.addVisualLog();
                this.drawVisualOverlay(this.visualFaces, data.frame);
            } else {
                this.visualFaces = [];
                this.visualFaceCount = 0;
                this.visualSummary = data.summary || { level: "오류", score: 0, signals: [data.message || "분석 실패"] };
                this.visualStatus = data.message || "분석 실패";
                this.drawVisualOverlay([], null);
            }
        } catch (e) {
            console.error(e);
            this.visualStatus = "영상 분석 호출 실패";
        }
        await this.service.render();
    }

    private addVisualLog() {
        this.visualLog.unshift({
            time: new Date().toLocaleTimeString(),
            level: this.visualSummary?.level || "-",
            faces: this.visualFaceCount,
            summary: (this.visualSummary?.signals || []).slice(0, 2).join(", ") || "-",
            inferMs: this.visualInferMs
        });
        if (this.visualLog.length > 20) this.visualLog.pop();
    }

    private syncVisualCanvasSize() {
        const canvas = this.visualCanvasElement?.nativeElement;
        const video = this.visualVideoElement?.nativeElement;
        if (!canvas || !video) return;
        if (canvas.width !== video.clientWidth || canvas.height !== video.clientHeight) {
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;
        }
    }

    private drawVisualOverlay(faces: any[], frame: any) {
        const canvas = this.visualCanvasElement?.nativeElement;
        const video = this.visualVideoElement?.nativeElement;
        if (!canvas || !video) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        this.syncVisualCanvasSize();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!faces || !frame) return;

        const frameW = frame.width || video.videoWidth;
        const frameH = frame.height || video.videoHeight;
        const videoRatio = frameW / frameH;
        const containerRatio = canvas.width / canvas.height;
        let drawWidth = 0;
        let drawHeight = 0;
        let offsetX = 0;
        let offsetY = 0;

        if (containerRatio > videoRatio) {
            drawWidth = canvas.width;
            drawHeight = canvas.width / videoRatio;
            offsetY = (canvas.height - drawHeight) / 2;
        } else {
            drawHeight = canvas.height;
            drawWidth = canvas.height * videoRatio;
            offsetX = (canvas.width - drawWidth) / 2;
        }

        const scaleX = drawWidth / frameW;
        const scaleY = drawHeight / frameH;
        faces.forEach((face) => {
            const region = face.bbox;
            const x = region.x * scaleX + offsetX;
            const y = region.y * scaleY + offsetY;
            const w = region.w * scaleX;
            const h = region.h * scaleY;
            const uncertain = face.expression === "uncertain";
            const color = uncertain ? "#f59e0b" : "#10b981";
            const label = `#${face.track_id} ${face.expression} ${this.fmtPct(face.confidence)}`;

            ctx.strokeStyle = color;
            ctx.lineWidth = 2;
            ctx.strokeRect(x, y, w, h);
            ctx.fillStyle = color;
            ctx.fillRect(x, Math.max(0, y - 24), Math.max(132, Math.min(220, w + 12)), 22);
            ctx.fillStyle = "#ffffff";
            ctx.font = "bold 12px sans-serif";
            ctx.fillText(label, x + 7, Math.max(15, y - 8));
        });
    }

    public topVisualExpressions(face: any) {
        if (!face || !face.expression_probs) return [];
        return Object.keys(face.expression_probs)
            .map(key => ({ label: key, value: face.expression_probs[key] }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 3);
    }

    private blobToDataUrl(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(String(reader.result || ""));
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    private initPlan() {
        this.stack = [
            { area: "Frontend", value: "WIZ Angular page, Web Audio API, MediaRecorder, optional Web Speech API" },
            { area: "Backend", value: "WIZ page API with faster-whisper/Silero/pyannote hooks" },
            { area: "VAD", value: "Silero VAD installed and used for speech timestamps" },
            { area: "STT", value: "HF Whisper medium fixed under /opt/app/models/hf-whisper-medium" },
            { area: "Diarization", value: "pyannote/speaker-diarization-3.1 with audio clustering + participant label fallback" },
            { area: "Utterance function", value: "BAAI/bge-m3 semantic function analysis + Korean rule fallback" },
            { area: "Text emotion", value: "dlckdfuf141/korean-emotion-kluebert-v2 + Korean conflict lexicon" },
            { area: "RAG/LLM", value: "ADR casebook 1,050건 primary RAG + KLAC 1차·2차 법률상담 Q&A 3,029건 + 국가법령정보 Open API 보조 근거" },
            { area: "Vision assist", value: "SCRFD face detection + HSEmotion/FERPlus expression candidate panel" }
        ];

        this.legalPipelineTerms = [
            "ADR-first taxonomy: casebook의 갈등 상황, 표면적 주장, 숨은 이해관계, 공통 관심사, 중재 절차, 합의안 패턴을 핵심 근거로 사용",
            "Legal support taxonomy: KLAC 1차 6개 분야 + 2차 6개 분야와 국가법령정보 API는 확인해야 할 사실과 절차를 보조",
            "LLM case understanding: 대화를 먼저 JSON으로 구조화해 분야, 하위 쟁점, 사용자 목표, 확인 사실, RAG 검색어, 답변 스타일을 결정",
            "ADR domain/issue routing: RAG 검색 전에 ADR 분야와 세부 issue를 먼저 분류하고, 분야나 issue가 맞지 않는 casebook 근거는 검색 후보에서 제외",
            "ADR case document RAG: casebook 사례 1건을 하나의 중재 사례 문서로 사용",
            "Query planning: ADR 사례 검색어와 보조 법률 검색어를 분리 생성",
            "Retrieval routing: casebook ADR 사례를 핵심 근거로, KLAC 상담 Q&A와 현행법령·판례 등 공식 자료를 보조 근거로 선택",
            "No silent fallback: LLM 사건 이해가 불가능하면 규칙 fallback 답변을 만들지 않고 불가 사유와 해결 방법을 표시",
            "Coach-frame generation: LLM 사건 이해와 ADR 근거를 바탕으로 쉬운 상황 요약, 표면적 주장, 숨은 이해관계, 공통 관심사, 중재 질문, 협의 행동을 구성",
            "RAG-grounded settlement proposal: 규칙 기반 절충값이 아니라 검색된 ADR 사례와 보조 법률 근거를 바탕으로 조건부 합의 초안을 생성",
            "LLM evidence selection: 검색 후보를 바로 쓰지 않고 LLM이 사건과 직접 관련 있는 RAG 문서만 채택한 뒤 합의안을 생성",
            "Silence-triggered coaching: 새 발화가 10초 이상 없으면 최근 대화 원문을 LLM 사건 이해 입력으로 사용하고 ADR 사례 근거를 검색",
            "Negotiable draft first: 화면에는 요약보다 표면적 주장, 숨은 이해관계, 공통 관심사, 참여자별 이행사항, 기한, 조건, 합의 불성립 시 다음 절차를 먼저 표시",
            "Context compression: 화면 상세 영역에는 검색 근거를 표시하고, LLM에는 압축 근거만 전달",
            "Human-in-the-loop guardrail: 위법, 승소 가능성, 책임 확정, 신고 필요성을 단정하지 않고 조정자 확인이 필요한 초안으로 표시"
        ];

        this.legalPipeline = [
            {
                order: 1,
                title: "대화 입력과 전사",
                description: "사용자가 말하거나 채팅으로 입력한 내용을 대화 로그로 만든다. 음성 입력은 HF Whisper medium이 텍스트로 변환하고 pyannote가 화자 후보를 나눈다.",
                current: "5초 오디오 청크, 수동 채팅 입력, 다중 참여자 라벨을 지원한다."
            },
            {
                order: 2,
                title: "감정·갈등 신호 분석",
                description: "유해표현, 감정 고조, 반복 비난, 금전·계약·책임·증거화·법적 대응 표현을 종합해 긴장도와 갈등 신호를 계산한다.",
                current: "감정/유해표현 모델과 범용 갈등 사전, BGE 쟁점 유사도 분석을 함께 사용한다."
            },
            {
                order: 3,
                title: "LLM 사건 이해와 검색어 생성",
                description: "최근 대화 원문을 LLM이 읽고 어떤 갈등 구조, 이해관계, 협의 목표, 보조 법률 쟁점에 가까운지 구조화한다.",
                current: "LLM 사건 이해 JSON과 ADR 분야/세부 issue 분류를 함께 사용해 ADR 사례 검색어와 보조 법령 검색어를 만든다."
            },
            {
                order: 4,
                title: "ADR 사례 우선 근거 검색",
                description: "casebook ADR 사례 1,050건에서 유사 갈등 구조, 숨은 이해관계, 중재 절차, 합의안 패턴을 우선 검색하고, 필요할 때 KLAC Q&A와 국가법령정보 API로 보강한다.",
                current: "새로 정리한 6개 PDF를 casebook_cases.jsonl로 변환해 우선 RAG 문서로 사용하고, 도메인 필터와 세부 issue 필터를 먼저 적용해 학교 단체채팅방, 온라인 쇼핑 반품 환불처럼 같은 큰 분야 안의 세부 쟁점을 분리한다."
            },
            {
                order: 5,
                title: "ADR 사례 기반 중재 답변 구성",
                description: "검색된 ADR 사례를 바탕으로 쉬운 상황 요약, 참여자별 입장, 표면적 주장, 숨은 이해관계, 공통 관심사, 확인할 사실, 중재 질문, 협의 행동을 구성한다.",
                current: "LLM 사건 이해가 성공한 경우에만 casebook 근거와 보조 법률 근거를 결합한다."
            },
            {
                order: 6,
                title: "중재안·해결 방향 생성",
                description: "검색된 ADR 근거와 LLM 사건 이해 결과를 함께 사용해 중립 재표현, 중재 질문, 협의 가능한 행동, 조건부 합의안·후속 점검 초안을 생성한다.",
                current: "새 발화가 10초 이상 없을 때 자동 생성되며, 위법·승소·책임 확정 판단 없이 LLM이 채택한 ADR RAG 근거 기반 합의 초안을 첫 결과로 표시한다."
            }
        ];

        this.stages = [
            {
                id: 1,
                title: "실시간 음성 전사 + 자동 화자분리",
                status: "ready",
                outcome: "브라우저 5초 오디오 청크를 서버로 보내 HF Whisper medium으로 전사하고, Silero VAD와 pyannote 화자분리 결과를 참여자 1, 참여자 2, 참여자 3... 형태의 다중 화자 라벨로 표시한다. BAAI/bge-m3는 화자 신원을 덮어쓰지 않고 문제 제기, 해명, 사과, 해결 제안 같은 발화 기능 후보를 보조 분석한다.",
                models: ["Silero VAD", "HF Whisper medium", "pyannote/speaker-diarization-3.1", "BAAI/bge-m3 utterance function analysis", "scikit-learn KMeans audio clustering fallback with 2~5 speaker candidate selection", "Korean rule-based speaker fallback"],
                build: ["브라우저 마이크 청크 수집 완료", "HF Whisper medium 고정 STT 연결 완료", "Silero 음성 구간 탐지 연결 완료", "HF Whisper medium 전사 연결 완료", "pyannote 화자 구간 매칭 코드 연결 완료", "SPEAKER_00/01/02...를 참여자 1/2/3... 다중 화자 라벨로 자동 매핑", "BAAI/bge-m3 임베딩으로 문제 제기, 해명/반박, 사과/공감, 해결 제안, 중재/정리 발화 기능 후보 분석", "BGE 발화 기능 기준 문장과 반복 발화 임베딩 캐싱 완료", "BGE 결과는 화자 신원 변경이 아니라 발화 기능 근거 배지로 표시", "발화 말풍선에 pyannote confidence, BGE 발화 기능 점수, 처리 근거 표시 완료", "오디오 디코딩, VAD, STT, pyannote, BGE/분석, 전체 처리 시간 모니터링 완료", "청크 경계에서 같은 화자의 짧거나 미종결된 발화를 이어 붙이는 MVP 병합 완료", "HF 토큰 또는 pyannote 실행 실패 시 음향 특징 군집화 폴백 완료", "음향 특징 군집 폴백은 2~5명 후보를 KMeans로 비교하고 silhouette score가 가장 높은 군집 수를 선택", "발화자 수동 보정 UI는 참여자 1~5, 조정자, 확인 필요를 선택 가능"],
                limits: ["현재는 pyannote가 분리한 음성 화자를 참여자 번호로 표시하는 구조이며 실제 이름이나 신원을 식별하지 않음", "BGE-M3는 음성을 듣는 모델이 아니라 전사 텍스트의 의미로 발화 기능 후보를 분석하는 모델임", "참여자가 많아질수록 목소리가 비슷한 사람, 겹침 발화, 짧은 맞장구에서 화자 라벨이 흔들릴 수 있음", "음향 군집 폴백은 pyannote보다 단순한 스펙트럼 특징 기반 방식이라 실제 화자 수를 보장하지 않고, 짧은 청크에서는 2~5명 후보 선택도 불안정할 수 있음", "현재 UI 수동 선택지는 참여자 1~5까지 제공하며 더 많은 참여자는 자동 라벨로 표시될 수 있으나 별도 이름 관리 기능은 아직 없음", "PDF가 지향하는 완전 실시간 대화 이해와 비교하면 현재는 5초 청크 기반 준실시간 MVP임", "BGE 모델과 Whisper medium의 첫 로딩은 느릴 수 있으나, BGE 기준 문장과 이전 발화 임베딩은 캐시로 재사용함", "Whisper medium은 small보다 정확도 실험에 유리할 수 있지만 CPU 환경에서는 지연 시간이 늘어날 수 있음", "청크 경계 병합은 MVP 방식이라 중복 전사나 잘못 병합된 문장이 생길 수 있음", "SPEAKER_00/01을 특정 실제 인물로 고정 식별하려면 세션별 임시 등록 음성 또는 조정자 확인이 필요함", "pyannote는 현재 환경에 연결되어 있으나, 새 서버나 재배포 환경에서는 Hugging Face 토큰, gated model 접근 승인, hf auth login 설정이 필요함"],
                future: ["참여자 1, 2, 3을 사용자가 임대인, 임차인, 중개인처럼 직접 이름/역할로 바꾸는 UI 추가", "참여자 수를 세션 중 동적으로 관리하고 병합/분리하는 화자 관리 패널 추가", "음향 군집 폴백의 선택된 군집 수와 silhouette score를 UI에 표시", "Whisper large-v3 후보 실험", "더 짧은 지연을 위한 streaming Whisper 또는 chunk stitching 정책 실험", "참여자별 세션 임시 등록 음성으로 SPEAKER_00/01 고정 식별", "BGE 캐시를 프로세스 메모리에서 영구 벡터 캐시로 확장", "청크 병합 중복 제거와 재분석 정확도 개선", "화자분리 정확도 평가용 라벨링/리뷰 패널 추가"],
                evidence: [
                    "Whisper는 대규모 약지도 학습 기반 ASR로 여러 데이터셋과 조건에서 강한 일반화 성능을 목표로 설계되어, 한국어 포함 다국어 전사 MVP의 기본 STT로 적합함. 근거: OpenAI Whisper paper, https://cdn.openai.com/papers/whisper.pdf",
                    "faster-whisper는 같은 Whisper 계열 모델을 CTranslate2로 재구현해 같은 정확도 목표에서 더 빠르고 메모리를 적게 쓰도록 설계되어, CPU 기반 5초 청크 MVP에 적합함. 근거: https://github.com/SYSTRAN/faster-whisper",
                    "pyannote.audio는 VAD, speaker change, overlapped speech, speaker embedding 등 화자분리 구성요소를 제공하는 공개 툴킷이며, diarization pipeline 구조가 연구 문헌으로 정리되어 있어 자동 화자분리 핵심 모델로 선택함. 근거: https://arxiv.org/abs/1911.01255, https://www.isca-archive.org/interspeech_2023/bredin23_interspeech.pdf",
                    "BGE-M3는 다국어 문장 임베딩 모델이므로, 전사 텍스트를 문제 제기, 해명/반박, 사과/공감, 해결 제안 같은 발화 기능 기준 문장과 비교하는 데 사용함. 화자 신원은 pyannote의 음성 기반 분리 결과를 우선함. 근거: https://huggingface.co/BAAI/bge-m3, https://arxiv.org/abs/2402.03216",
                    "Silero VAD는 8kHz/16kHz 입력과 짧은 청크 처리를 지원하고 다양한 도메인/노이즈 조건을 목표로 하는 공개 VAD라서, 서버 전사 전 음성 구간 탐지 보조에 적합함. 근거: https://github.com/Sahl-AI/silero-vad",
                    "5초 청크는 완전 스트리밍보다 구현 리스크가 낮고, pyannote 구간과 Whisper segment를 시간 기준으로 매칭하기 쉬운 준실시간 절충안임. 이후 요구 지연 시간이 낮아지면 Whisper-Streaming 계열 정책으로 전환 가능함."
                ]
            },
            {
                id: 2,
                title: "텍스트 기반 갈등 분석 엔진",
                status: "ready",
                outcome: "화자별 발화를 기반으로 감정 고조와 갈등 신호를 분석하고, 금전·계약·책임·증거화·안전 위험 같은 분쟁 후보 유형을 찾아 STEP 3의 법률 근거 검색으로 넘긴다.",
                models: ["jinkyeongk/kcELECTRA-toxic-detector via transformers", "dlckdfuf141/korean-emotion-kluebert-v2 via transformers", "BAAI/bge-m3 via sentence_transformers", "Korean conflict/emotion lexicon", "General conflict lexicon for money, contract, apology, workplace, tenancy, consumer, legal-action signals", "TF-IDF/KMeans issue clustering fallback"],
                build: ["문장 단위 유해표현 모델 점수 연결 완료", "KLUE-BERT 기반 7개 감정 클래스 분류 연결 완료", "감정 모델 출력은 공포/놀람/분노/슬픔/중립/행복/혐오 라벨로 정규화 완료", "분노·혐오·공포·슬픔 중심 정서 고조 점수화 완료", "BAAI/bge-m3로 전사 텍스트와 미리 정의한 쟁점 후보 문장의 의미 유사도 비교 완료", "BGE 쟁점 기준 문장과 반복 발화 임베딩 캐싱 완료", "유해표현·감정 모델 발화별 결과 캐싱 완료", "서버 모델 확인 시 BGE·유해표현·감정 모델 사전 로딩 및 워밍업 완료", "금전, 계약/약속, 책임/사과, 증거화/법적 대응, 직장/학교, 임대차/소비자, 명예/개인정보, 안전 위험 표현 사전 연결 완료", "범용 갈등 표현 가중치를 긴장도 계산에 반영 완료", "반복 비난/불신/위협/경멸/직접 반박 규칙 탐지 완료", "화자별 발화 횟수와 발화량 편중 지표 완료", "긴 침묵 후 재발화 지표 연결 완료", "BGE 실패 시 키워드 기반 쟁점 추정 폴백 완료", "TF-IDF/KMeans 쟁점 클러스터링 폴백 완료", "분석된 쟁점과 긴장도는 STEP 3의 법률 RAG 질의와 중재안 생성 입력으로 사용", "사용자 화면에서는 처리 시간 같은 개발자용 성능 수치를 숨기고 갈등 신호 중심으로 표시"],
                limits: ["현재는 문장 단위 감정/유해표현 분석과 규칙 기반 범용 갈등 사전 중심의 MVP임", "범용 갈등 사전은 프로토타입용 규칙이라 실제 법률 분야별 표현을 모두 포괄하지 못함", "유해표현/감정 분석은 판정이 아니라 조정자 검토 신호임", "감정 모델은 일반 한국어 감성 대화 기반이라 법률 분쟁 맥락이나 일상 갈등의 숨은 의도를 완벽하게 이해하지 못할 수 있음", "공포·분노·혐오 같은 라벨은 실제 감정 단정이 아니라 텍스트상 정서 후보로만 표시함", "BAAI/bge-m3는 주제를 자유롭게 생성하는 GPT형 모델이 아니라, 현재 발화와 미리 정의한 쟁점 후보 문장의 의미 유사도를 비교하는 임베딩 모델임", "현재 구현은 최근 5~10개 발화를 LLM이 읽어 감정 고조 원인과 반복 요구를 요약하는 맥락 분석 레이어는 아직 없음", "BAAI/bge-m3와 transformers 모델의 첫 서버 워밍업은 여전히 시간이 걸릴 수 있음", "현재 캐시는 프로세스 메모리 기준이라 서버 재시작 시 초기화됨", "kcELECTRA-toxic-detector의 LABEL 매핑은 모델카드 검증 없이 단독 처분 기준으로 쓰면 안 됨", "반어법, 은어, 사투리, 맥락 생략 표현에 취약함", "자동 처분이나 법적 평가에 사용하면 안 됨"],
                future: ["생활법령, 소비자분쟁, 임대차, 노동, 학교폭력, 명예훼손 등 분야별 공개 자료를 바탕으로 갈등 사전 세분화", "금전·계약·임대차·소비자·직장·학교·가족·명예훼손 등 일상 갈등 유형별 쟁점 후보 문장 확장", "민사·형사·행정·지식재산권·노동·소비자 등 법률 분야 분류기 추가", "감정 모델, 유해표현 모델, 범용 갈등 사전, BGE 검색, 로컬 LLM 맥락 요약을 결합한 하이브리드 분석 구조로 확장", "민사·형사·행정·지식재산권 로컬 법률 LLM으로 최근 5~10개 발화에서 핵심 쟁점, 감정 고조 원인, 반복 요구사항, 개입 필요 사유를 요약하고 법률 RAG 검색 질의로 활용", "LLM 기반 쟁점 자동 추출 결과를 조정자 검토 후보로 표시하고 대화에 없는 쟁점 생성 여부를 확인", "운영 단계에서는 익명화된 범용 갈등 상담 데이터로 KLUE-RoBERTa 또는 KoELECTRA 기반 맥락 분류 모델을 fine-tuning", "정답 라벨 기반 precision/recall 평가 패널 추가", "텍스트 분석 캐시를 프로세스 메모리에서 영구 캐시로 확장", "BGE-M3와 Qdrant 연동", "조정자 피드백을 누적해 위험 신호 임계값 개인화"],
                evidence: [
                    "유해표현은 갈등 고조의 직접 신호가 될 수 있지만 조정 맥락에서는 오탐 비용이 크므로 모델 점수와 규칙 신호를 함께 표시하고 최종 판단은 사람에게 남김. 근거 모델: https://huggingface.co/jinkyeongk/kcELECTRA-toxic-detector",
                    "dlckdfuf141/korean-emotion-kluebert-v2는 klue/bert-base 기반 한국어 감정 분류 모델이며 공포, 놀람, 분노, 슬픔, 중립, 행복, 혐오 7개 클래스를 제공해 한국어 발화의 정서 고조 후보 탐지에 적합함. 근거: https://huggingface.co/dlckdfuf141/korean-emotion-kluebert-v2",
                    "BGE-M3는 dense, sparse, multi-vector retrieval을 지원하는 다국어 임베딩 모델로 쟁점 유사도와 클러스터링 보조에 적합함. 근거: https://huggingface.co/BAAI/bge-m3, https://arxiv.org/abs/2402.03216",
                    "현재 쟁점 분석은 BGE-M3가 새 주제명을 생성하는 방식이 아니라, 전사 텍스트와 미리 정의한 쟁점 후보 문장의 의미 유사도를 비교해 가장 가까운 후보를 찾는 방식임.",
                    "민사·형사·행정·지식재산권 로컬 법률 LLM 같은 생성형 모델은 대화 로그에서 핵심 쟁점과 감정 고조 원인을 자유롭게 요약할 수 있지만, CPU 환경에서는 느리고 근거 없는 쟁점을 만들 수 있어 조정자 검토 후보로 제한하는 설계가 필요함.",
                    "감정과 맥락을 모두 잘 분석하려면 단일 모델보다 문장 단위 감정/유해표현 모델, 범용 갈등 사전, BGE 근거 검색, LLM 맥락 요약, 조정자 검토를 결합하는 하이브리드 구조가 적합함.",
                    "텍스트 감정 분류기는 반어법과 도메인 이동에 취약하므로 단일 모델 출력보다 규칙 기반 갈등 사전, 도메인별 표현 사전, 화자별 발화량, 침묵 시간 같은 구조적 신호를 함께 쓰는 다중 신호 접근이 안전함.",
                    "범용 일상 갈등에서는 욕설이 없어도 책임 요구, 사과 요구, 금전 반환 요구, 계약 불이행 주장, 증거화, 법적 대응 예고 같은 표현이 갈등 고조 신호가 될 수 있어 별도 사전과 가중치가 필요함.",
                    "조정자 대시보드는 자동 판정이 아니라 개입 우선순위와 질문 방향을 돕는 설명 가능한 신호 모음으로 설계함.",
                    "사전 로딩과 결과 캐시는 프로토타입 실험에서 반복 발화 분석 지연을 줄이기 위한 내부 최적화이며, 사용자 화면에는 갈등 신호와 중재 방향만 우선 표시함."
                ]
            },
            {
                id: 3,
                title: "ADR casebook 기반 AI 중재 코치 + 법률 보조 RAG",
                status: "ready",
                outcome: "Prototype5를 법률상담 챗봇이 아니라 ADR 사례 기반 AI 중재 코치로 재정의했다. 이번 추가 작업에서는 STEP 3의 RAG 자료를 새 casebook PDF 6개 기준으로 확장해 1,050개 중재 사례를 사례 단위 RAG로 만들고, 법률 RAG와 국가법령정보 API는 최종 판단이 아니라 확인해야 할 사실과 절차를 보조하는 참고자료로 사용한다.",
                models: ["AI conflict mediation casebook 1,050개 ADR 사례", "대한법률구조공단_법률상담 사례질문답변_1차 1,938건", "대한법률구조공단_법률상담 사례질문답변_2차 유효 Q&A 1,091건", "LLM case understanding JSON layer", "casebook_cases.jsonl primary ADR RAG", "KLAC Q&A JSONL support RAG", "국가법령정보센터 Open API via LAW_API_OC", "Qwen2.5-7B-Instruct-GGUF 또는 llama.cpp server 기반 사건 이해와 중재안 생성", "conversation summary cache"],
                build: ["STEP 3만 추가 개선: 음성 전사, 감정 분석, 평가 체계가 아니라 ADR casebook RAG 자료와 검색 라우팅을 보강", "rag_sources/casebook 아래 temp_ PDF 7개를 SHA-256, 파일 크기, 페이지 수, 제목/수록 범위로 비교해 동일 중복 1개를 제거", "최종 유지 PDF 6개를 대상으로 OCR 없이 pypdf 텍스트 레이어에서 사례를 추출", "Vol.1~Vol.4 추가 사례 1,000건과 기본 사례집 50건을 합쳐 총 1,050개 ADR 사례를 구조화", "연구/설계 PDF는 사례형 문서가 아니므로 source metadata에는 포함하되 사례 JSONL에는 넣지 않음", "새 RAG 파일 casebook_cases.jsonl과 casebook_index_metadata.json 생성 완료", "각 사례를 case_id, domain, issue, risk_level, participants, surface_claims, hidden_interests, common_ground, objective_facts, mediator_questions, negotiable_actions, settlement_draft, evidence_codes, source_file, page_range로 저장", "기존 casebook.rag.jsonl은 보존하고, 실제 앱 로더는 새 casebook_cases.jsonl을 우선 읽도록 연결", "RAG 검색에서 domain, issue, keywords, source_file, page_range를 후보 문서에 포함해 세부 쟁점 중심 검색이 가능하도록 보강", "RAG 검색 전에 predicted_domain과 predicted_issue를 내부 생성하고, UI 노출 없이 검색 라우팅에 사용", "predicted_domain이 정해지면 관련 없는 casebook 도메인은 후보에서 제외하도록 도메인 필터 적용", "학교 단체채팅방 입력은 학교·청소년·디지털 갈등 / 단체채팅방 괴롭힘으로 분류되어 단체 채팅방 배제 사례가 우선 검색됨", "온라인 쇼핑 반품 환불 입력은 플랫폼·전자상거래·배달 / 온라인 쇼핑 반품 환불 지연으로 분류되어 온라인 쇼핑 반품 환불 지연 사례가 우선 검색됨", "실제 중재안 생성 경로에서 학교 갈등은 상속·유언 근거가 선택되지 않고, 반품 환불은 중고거래 미배송 근거가 선택되지 않음을 확인", "ADR-first 원칙에 따라 KLAC 보조 법률 근거는 분야 라벨이 맞을 때만 선택하고, 맞는 근거가 없으면 보조 법률 근거 없음으로 처리", "Qwen 생성 프롬프트는 법률 판단자가 아니라 ADR 중재 코치 역할을 유지", "최종 출력에 쉬운 상황 요약, 참여자별 입장, 표면적 주장, 숨은 이해관계, 공통 관심사, 확인해야 할 사실, 중재 질문, 협의 가능한 행동, 조건부 합의안 초안, 합의 불성립 시 다음 절차, 비법률자문 고지를 포함", "위법, 승소 가능성, 책임 확정, 신고 필요성 단정 금지와 Human-in-the-loop 조건을 프롬프트와 고지에 반영", "화면 첫 결과를 AI 중재안 초안으로 유지하되 ADR 구조 필드를 합의안 앞에 표시"],
                limits: ["casebook은 교육용으로 재구성된 ADR 사례이므로 법률 판단 근거가 아니라 중재 구조와 합의안 형식 근거로 사용해야 함", "KLAC 상담사례와 국가법령정보 API는 보조 근거이며 개별 사건의 책임, 위법, 승소 가능성을 보장하지 않음", "이번 작업은 평가 체계 수정이 아니라 STEP 3의 RAG 자료 확장과 검색 라우팅 개선임", "새 PDF 변환은 텍스트 레이어 기반이므로 원본 PDF의 텍스트 추출 품질에 영향을 받음", "연구/설계 PDF처럼 사례 구조가 아닌 문서는 casebook_cases.jsonl 사례에는 포함하지 않음", "LLM 사건 이해가 필수이므로 로컬 GGUF 모델이나 llama.cpp server가 준비되지 않으면 상담형 답변을 생성하지 않고 설정 필요 상태를 표시함", "LLM 사건 이해 결과도 법률 판단이 아니므로 애매한 질문은 조정자와 사람이 분야와 사실관계를 확인해야 함", "법률 기반 해결책은 법률 자문이나 승소 가능성 판단이 아니라 관련 절차와 준비 자료 안내로 제한함", "민감정보가 포함된 대화는 외부 API 전송 전에 익명화와 동의가 필요함"],
                future: ["casebook 1,050개 사례의 domain/issue/keywords 품질을 사람이 검토해 실제 서비스 분류표와 더 정밀하게 매핑", "Qdrant 또는 SQLite FTS 기반 영구 인덱스로 ADR 사례 검색 속도와 재정렬 품질 개선", "학교·청소년, 전자상거래, 직장, 의료, 개인정보처럼 새 자료에서 늘어난 도메인의 세부 issue 라우팅을 단계적으로 확장", "KLAC 법률상담 근거와 casebook ADR 근거가 충돌하거나 역할이 혼동되는 경우를 표시하는 경고 로직 추가", "대표 시나리오 확장이나 평가 기준 강화는 별도 단계에서 진행"],
                evidence: [
                    "casebook은 갈등 상황, 표면적 주장, 숨은 이해관계, 공통 관심사, 중재 절차, 합의안, 후속 점검을 포함하므로 법률상담보다 ADR 중재안 생성에 더 직접적인 핵심 RAG 근거임.",
                    "대한법률구조공단 1차·2차 데이터는 법률분류, 유사질문, 유사답변, 주요법령, 판례 구조라서 확인해야 할 사실과 절차를 보조하는 법률 참고 근거로 적합함.",
                    "법령 원문 중심 검색은 '민법 제390조' 같은 정보 제공에는 강하지만, 교수님 요구사항인 당사자 간 합의와 조정에는 casebook의 합의안 패턴이 더 직접적임.",
                    "국가법령정보 API는 최신 조문과 공식 근거 확인에 유용하지만, ADR 중재안의 최종 판단 근거가 아니라 보조 검증 레이어로 둠.",
                    "이번 STEP 3 개선으로 새 casebook PDF 6개에서 1,050개 ADR 사례를 추출하고 casebook_cases.jsonl을 실제 RAG 우선 소스로 연결함.",
                    "도메인과 세부 issue를 검색 전에 분류해 학교 단체채팅방 괴롭힘이 가족·상속 근거로 흐르거나, 온라인 쇼핑 반품 환불 지연이 중고거래 미배송 근거로 흐르는 문제를 차단함.",
                    "실제 생성 경로 테스트에서 학교 단체채팅방 입력은 학교·청소년·디지털 갈등 / 단체채팅방 괴롭힘으로, 반품 환불 입력은 플랫폼·전자상거래·배달 / 온라인 쇼핑 반품 환불 지연으로 라우팅됨.",
                    "casebook_index_metadata.json에는 PDF별 페이지 수, 텍스트 추출량, 사례 수, 도메인별 사례 수, 중복 판정 정보를 기록함.",
                    "RAG는 모델 파라미터에 없는 전문 지식을 외부 문서 검색으로 보강하는 구조라서, ADR 사례와 보조 법률 근거를 함께 제시하는 STEP 3에 적합함. 근거: Lewis et al., Retrieval-Augmented Generation, https://arxiv.org/abs/2005.11401",
                    "법률 조항은 변동 가능하고 개별 사건 적용 책임이 크므로, Prototype5 답변은 비법률자문 고지와 Human-in-the-loop 조건을 포함해야 함."
                ]
            },
            {
                id: 4,
                title: "얼굴·표정·행동 보조 분석",
                status: "ready",
                outcome: "SCRFD 얼굴 탐지와 HSEmotion/FERPlus 표정 추정 파이프라인을 갈등 판정이 아닌 조정자 확인용 표정 후보 보조 패널로 연결한다.",
                models: ["SCRFD 2.5G BNKPS ONNX", "HSEmotion enet_b0_8_best_afew", "FERPlus ONNX fallback", "OpenCV", "IoU 기반 face track 유지", "최근 5프레임 표정 확률 smoothing"],
                build: ["웹캠 프레임 캡처와 서버 전송 완료", "SCRFD 기반 다중 얼굴 탐지 완료", "얼굴별 track_id 유지 완료", "HSEmotion 표정 확률 추정 연결 완료", "HSEmotion 실패 시 FERPlus ONNX fallback 유지", "최근 5프레임 표정 확률 smoothing 완료", "얼굴 크기, 흐림, 밝기, 측면 얼굴 품질 점수 표시 완료", "anger/fear/contempt 등은 감정 판정이 아니라 표정 후보 신호로만 표시", "원본 영상 저장 없이 화면 메모리와 최근 로그만 유지", "조정자 확인 필요 신호와 윤리적 제한 고지 표시 완료"],
                limits: ["범용 일상 대화 서비스에서 영상 분석은 선택 기능이며, 음성·텍스트 분석 없이 단독으로 갈등이나 법률 판단에 사용하면 안 됨", "PDF의 트라이모달 감정 인식 요구사항과 비교하면 현재 STEP 4는 얼굴 탐지 + 표정 후보 추정만 구현함", "손 비비기, 턱 만지기, 어깨 위축 같은 상반신/손 미세 행동은 아직 탐지하지 않음", "음성 감정 특징, 텍스트 긴장도, 영상 신호를 하나의 시계열로 융합하는 단계는 아직 구현하지 않음", "표정 후보로 실제 감정, 공격성, 거짓말, 정신상태를 단정하지 않음", "조명, 가림, 마스크, 측면 얼굴, 작은 얼굴에서 오탐과 미탐 가능성이 큼", "일상 갈등 상황에서 불이익 처분이나 법적 판단에 사용하면 안 됨"],
                future: ["범용 서비스에서는 영상 분석을 기본 기능이 아니라 사용자 동의 기반 선택 기능으로 제공", "MediaPipe Face Landmarker로 시선, 눈 깜빡임, head pose 변화량 추가", "MediaPipe Pose/Hand Landmarker로 손 비비기, 얼굴 만지기, 어깨 위축 등 상반신 미세 거동 추가", "STEP 1 음성 타임라인과 STEP 2 텍스트 긴장도에 영상 신호를 시간축으로 정렬", "음성·텍스트·영상 신호를 각각 독립 신호로 표시한 뒤 조정자 확인용 종합 패널로 결합", "개인별 baseline 보정과 현장 라벨 데이터 기반 임계값 검증", "얼굴 좌표 마스킹, 접근권한 로그, 비저장 정책 고지 등 개인정보 보호 장치 강화"],
                evidence: [
                    "PDF는 STEP 4를 음성, 표정, 미세 신체 거동을 결합하는 트라이모달 감정 합성 인식으로 설명하지만, 현재 구현 범위는 안전한 1차 MVP로 얼굴 탐지와 표정 후보 추정에 제한함.",
                    "SCRFD는 다중 얼굴 bbox와 5개 keypoint를 찾고, 얼굴 crop 정렬 뒤 HSEmotion 또는 FERPlus가 얼굴별 8개 표정 확률을 추정함. 같은 얼굴은 IoU 기반 track_id로 이어 붙이고 최근 5프레임 확률 평균으로 라벨 흔들림을 완화함.",
                    "표정 분석은 EMFACS/Action Unit 계열 연구처럼 얼굴 근육 변화에서 정서 단서를 얻는다는 근거가 있지만, 실제 감정이나 공격성을 단정할 수 없으므로 조정자 확인 신호로만 표시함.",
                    "범용 법률 갈등 서비스에서는 영상 분석 결과가 법률 판단이나 책임 판단으로 오해되지 않도록, 텍스트·음성 분석과 분리된 보조 신호로 표시해야 함.",
                    "PDF의 미세 신체 거동 예시인 손 비비기, 턱 만지기, 어깨 위축은 얼굴 표정 모델만으로는 탐지할 수 없어 추후 Pose/Hand Landmarker 확장 항목으로 분리함.",
                    "Human-in-the-loop 원칙에 따라 위험 제어와 갈등 판단은 AI가 아니라 인간 조정자 콘솔에 남기도록 설계함."
                ]
            }
        ];

        this.safeguards = [
            "AI 결과는 조정자 검토 신호로만 사용",
            "화자 라벨은 확신도와 함께 표시하고 수동 수정 가능하게 설계",
            "얼굴/표정 분석은 감정 단정 대신 변화량과 개입 검토 신호로 제한",
            "국가법령정보 API 인증값은 프론트와 코드에 저장하지 않고 서버 환경변수 LAW_API_OC로만 주입",
            "국가법령정보 API는 대표 검색어 제한, 상위 후보 본문 조회, 7일 캐시로 과호출을 방지",
            "법률 근거 기반 해결책은 관련 법령·절차 후보와 참고 초안으로만 표시",
            "승소 가능성, 처벌 가능성, 최종 법률 판단은 제공하지 않고 전문가 확인 대상으로 남김",
            "데이터/백업 디렉터리는 수정하지 않고 모델은 /opt/app/models 아래에만 둠"
        ];
    }
}

export default PagePrototype5Component;